<template>
  <div class="goal" ref="goal">
    <div class="filters">
      <template v-for="(category, index) in categories">
        <BCheckbox
          v-model="categoriesSelected"
          :key="index"
          :native-value="category.category_id"
          :name="category.category_name"
          @change.native="onClickCategory"
        >
          <div class="checkbox-list">
            {{ $t(category.translationKey) }}
            <IconBall width="12px" height="12px" :color="category.category_color" :st="category.st"> </IconBall>
          </div>
        </BCheckbox>
      </template>
    </div>
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 888.5 651.6"
      style="enable-background:new 0 0 888.5 651.6;"
      xml:space="preserve"
    >
      <g>
        <path
          class="st0"
          d="M680.2,345.5c0.1,0,0.1,0,0.1,0l0.1,0c0.2,0,0.3,0.1,0.4,0.1l100.7,29.7c2.3,0.7,3.7,1.4,3,3.7c-0.6,1.9-2.3,
          3.2-4.2,3.2c-0.4,0-0.8-0.1-1.3-0.2L679,354.3H201.3L102.8,382c-0.4,0.1-0.8,0.2-1.2,0.2c-1.9,
          0-3.6-1.3-4.2-3.2c-0.7-2.3,0.6-3,2.9-3.7l98.7-29.5c0.5-0.2,1-0.3,1.6-0.3c0.1,0,0.2,0,0.3,0h478.7C679.7,
          345.4,680,345.4,680.2,345.5z"
        />
        <path
          class="st1"
          d="M684.9,334.3l-0.2,15l0.5,0.2l0.2-17L684.9,334.3z M688.7,320.6l-0.4,29.8l0.5,0.2l0.4-31.8L688.7,
          320.6zM692.6,306.3l-0.6,45.3l0.5,0.2l0.6-47.4L692.6,306.3z M696.8,291.3l-0.7,61.6l0.5,0.2l0.8-63.6L696.8,
          291.3z M701.2,275.5l-0.9,78.7l0.5,0.2l0.9-80.7L701.2,275.5z M705.7,258.9l-1,96.7l0.5,0.2l1-98.7L705.7,
          258.9z M710.6,241.5l-1.1,115.6l0.5,0.2l1.2-117.6L710.6,241.5z M715.6,223.1l-1.2,135.5l0.5,
          0.2l1.3-137.5L715.6,223.1z M721,203.7l-1.3,156.5l0.5,0.2l1.3-158.6L721,203.7z M726.9,182.3l-0.3,
          0.9L725.3,362l0.5,0.2l1.4-180L726.9,182.3z M732.5,178.8l-1.2,185.1l0.5,0.2l1.2-185.6L732.5,178.8z M738.8,
          174.8l-1.1,191.1l0.5,0.2l1.1-191.6L738.8,174.8z M745.5,170.6l-0.9,197.5l0.5,0.2l0.9-197.9L745.5,
          170.6z M752.6,166.1l-0.8,204.3l0.5,0.2l0.8-204.7L752.6,166.1z M760.3,161.3l-0.5,211.6l0.5,
          0.2l0.5-212.1L760.3,161.3z M768.5,156l-0.3,219.5l0.5,0.2l0.3-219.9L768.5,156z M777.4,150.4v228l0.5,
          0.2V214.8l-0.2-64.6L777.4,150.4z"
        />
        <g transform="translate(583.846 5.444)">
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter"
              filterUnits="userSpaceOnUse"
              x="101.2"
              y="62.7"
              width="93.6"
              height="92.5"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="101.2" y="62.7" width="93.6" height="92.5" id="prefix__b_1_">
            <g class="st2">
              <path id="prefix__a_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path
            class="st4"
            d="M102.2,154.9l-0.3-0.4c23.2-22,54.9-53.5,91.8-91.1l0.4,0.3C157.1,101.4,125.4,132.9,102.2,154.9"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_1_"
              filterUnits="userSpaceOnUse"
              x="101.1"
              y="75.1"
              width="93.7"
              height="87.8"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="101.1" y="75.1" width="93.7" height="87.8" id="prefix__d_1_">
            <g class="st5">
              <path id="prefix__c_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path
            class="st6"
            d="M102.1,162.5l-0.3-0.4c23.2-21.5,55-51.3,91.9-86.4l0.3,0.4C157.1,111.2,125.3,141.1,102.1,162.5"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_2_"
              filterUnits="userSpaceOnUse"
              x="101"
              y="87.5"
              width="93.7"
              height="83.1"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="101" y="87.5" width="93.7" height="83.1" id="prefix__f_1_">
            <g class="st7">
              <path id="prefix__e_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path class="st8" d="M102,170.2l-0.3-0.4c23.2-21,55-49.2,92-81.6l0.3,0.4C157,121,125.2,149.2,102,170.2" />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_3_"
              filterUnits="userSpaceOnUse"
              x="100.9"
              y="100"
              width="93.8"
              height="78.3"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="100.9" y="100" width="93.8" height="78.3" id="prefix__h_1_">
            <g class="st9">
              <path id="prefix__g_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path
            class="st10"
            d="M101.9,177.9l-0.3-0.4c23.2-18.3,55.1-44.9,92.1-76.8l0.3,0.4C156.9,133,125.1,159.6,101.9,177.9"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_4_"
              filterUnits="userSpaceOnUse"
              x="100.8"
              y="112.6"
              width="93.9"
              height="73.5"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="100.8" y="112.6" width="93.9" height="73.5" id="prefix__j_1_">
            <g class="st11">
              <path id="prefix__i_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path
            class="st12"
            d="M101.8,185.7l-0.3-0.4c23.3-17.9,55.1-42.8,92.2-72l0.3,0.4C156.9,142.9,125,167.8,101.8,185.7"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_5_"
              filterUnits="userSpaceOnUse"
              x="100.7"
              y="125.2"
              width="94"
              height="68.7"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="100.7" y="125.2" width="94" height="68.7" id="prefix__l_1_">
            <g class="st13">
              <path id="prefix__k_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path
            class="st14"
            d="M101.7,193.4l-0.3-0.4c23.3-17.4,55.2-40.6,92.3-67.2l0.3,0.4C156.8,152.8,124.9,176,101.7,193.4"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_6_"
              filterUnits="userSpaceOnUse"
              x="100.6"
              y="137.8"
              width="94.1"
              height="63.8"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="100.6" y="137.8" width="94.1" height="63.8" id="prefix__n_1_">
            <g class="st15">
              <path id="prefix__m_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path
            class="st16"
            d="M101.5,201.2l-0.3-0.4c23.3-14.7,55.2-36.2,92.4-62.3l0.3,0.4C156.8,165,124.8,186.5,101.5,201.2"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_7_"
              filterUnits="userSpaceOnUse"
              x="100.5"
              y="150.5"
              width="94.2"
              height="58.9"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="100.5" y="150.5" width="94.2" height="58.9" id="prefix__p_1_">
            <g class="st17">
              <path id="prefix__o_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path
            class="st18"
            d="M101.4,209l-0.3-0.4c23.3-14.2,55.3-34.1,92.5-57.4l0.3,0.4C156.8,174.9,124.8,194.7,101.4,209"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_8_"
              filterUnits="userSpaceOnUse"
              x="100.4"
              y="163.2"
              width="94.2"
              height="54"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="100.4" y="163.2" width="94.2" height="54" id="prefix__r_1_">
            <g class="st19">
              <path id="prefix__q_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path
            class="st20"
            d="M101.3,216.8l-0.3-0.4c23.3-13.7,55.3-31.8,92.6-52.4l0.2,0.4C156.7,184.9,124.6,203.1,101.3,216.8"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_9_"
              filterUnits="userSpaceOnUse"
              x="100.3"
              y="176"
              width="94.3"
              height="49"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="100.3" y="176" width="94.3" height="49" id="prefix__t_1_">
            <g class="st21">
              <path id="prefix__s_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
            </g>
          </mask>
          <path
            class="st22"
            d="M101.2,224.6l-0.2-0.5c23.3-11,55.4-27.4,92.7-47.5l0.2,0.4C156.6,197.2,124.5,213.6,101.2,224.6"
          />
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_10_"
                filterUnits="userSpaceOnUse"
                x="100.2"
                y="188.8"
                width="94.4"
                height="44"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="100.2" y="188.8" width="94.4" height="44" id="prefix__v_1_">
              <g class="st23">
                <path id="prefix__u_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
              </g>
            </mask>
            <path
              class="st24"
              d="M101.1,232.4l-0.2-0.5c23.4-10.5,55.5-25.2,92.9-42.5l0.2,0.5C156.6,207.2,124.4,221.9,101.1,232.4"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_11_"
                filterUnits="userSpaceOnUse"
                x="100.1"
                y="201.7"
                width="94.4"
                height="39"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="100.1" y="201.7" width="94.4" height="39" id="prefix__x_1_">
              <g class="st25">
                <path id="prefix__w_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
              </g>
            </mask>
            <path
              class="st26"
              d="M101,240.3l-0.2-0.5c23.3-10,55.5-22.9,93-37.4l0.2,0.5C156.4,217.4,124.3,230.3,101,240.3"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_12_"
                filterUnits="userSpaceOnUse"
                x="100.1"
                y="214.7"
                width="94.5"
                height="34"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="100.1" y="214.7" width="94.5" height="34" id="prefix__z_1_">
              <g class="st27">
                <path id="prefix__y_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
              </g>
            </mask>
            <path
              class="st28"
              d="M100.8,248.2l-0.2-0.5c23.4-7.2,55.5-18.4,93.1-32.4l0.2,0.5C156.4,229.8,124.2,240.9,100.8,248.2"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_13_"
                filterUnits="userSpaceOnUse"
                x="100"
                y="227.7"
                width="94.6"
                height="28.9"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="100" y="227.7" width="94.6" height="28.9" id="prefix__B_1_">
              <g class="st29">
                <path id="prefix__A_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
              </g>
            </mask>
            <path
              class="st30"
              d="M100.7,256l-0.1-0.5c23.4-6.7,55.6-16.1,93.2-27.3l0.1,0.5C156.3,239.9,124.1,249.4,100.7,256"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_14_"
                filterUnits="userSpaceOnUse"
                x="99.9"
                y="240.7"
                width="94.6"
                height="23.7"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="99.9" y="240.7" width="94.6" height="23.7" id="prefix__D_1_">
              <g class="st31">
                <path id="prefix__C_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
              </g>
            </mask>
            <path
              class="st32"
              d="M100.6,263.9l-0.1-0.5c23.4-6.2,55.7-13.8,93.3-22.2l0.1,0.5C156.3,250.1,124,257.8,100.6,263.9"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_15_"
                filterUnits="userSpaceOnUse"
                x="99.8"
                y="253.8"
                width="94.6"
                height="18.6"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="99.8" y="253.8" width="94.6" height="18.6" id="prefix__F_1_">
              <g class="st33">
                <path id="prefix__E_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
              </g>
            </mask>
            <path
              class="st34"
              d="M100.5,271.9l-0.1-0.5c23.4-3.4,55.7-9.2,93.4-17l0.1,0.5C156.2,262.6,123.9,268.5,100.5,271.9"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_16_"
                filterUnits="userSpaceOnUse"
                x="99.7"
                y="267"
                width="94.7"
                height="13.4"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="99.7" y="267" width="94.7" height="13.4" id="prefix__H_1_">
              <g class="st35">
                <path id="prefix__G_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
              </g>
            </mask>
            <path
              class="st36"
              d="M100.3,279.8l-0.1-0.5c23.5-2.9,55.8-6.9,93.5-11.8l0.1,0.5C156.2,272.9,123.9,277,100.3,279.8"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_17_"
                filterUnits="userSpaceOnUse"
                x="99.6"
                y="280.2"
                width="94.7"
                height="8.1"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="99.6" y="280.2" width="94.7" height="8.1" id="prefix__J_1_">
              <g class="st37">
                <path id="prefix__I_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
              </g>
            </mask>
            <path
              class="st38"
              d="M100.2,287.8l0-0.5c23.5-2.3,55.8-4.6,93.6-6.6l0,0.5C156.1,283.2,123.7,285.5,100.2,287.8"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_18_"
                filterUnits="userSpaceOnUse"
                x="99.6"
                y="293.4"
                width="94.8"
                height="3"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="99.6" y="293.4" width="94.8" height="3" id="prefix__L_1_">
              <g class="st39">
                <path id="prefix__K_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5" />
              </g>
            </mask>
            <path
              class="st40"
              d="M120.8,296c-7.5,0-14.4-0.1-20.7-0.2l0-0.5c23.5,0.5,55.9,0.1,93.7-1.3l0,0.5
        C166.1,295.5,141.3,296,120.8,296"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_19_"
                filterUnits="userSpaceOnUse"
                x="99.5"
                y="302.7"
                width="94.9"
                height="5.5"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="99.5" y="302.7" width="94.9" height="5.5" id="prefix__N_1_">
              <g class="st41">
                <path id="prefix__M_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z" />
              </g>
            </mask>
            <path
              class="st42"
              d="M193.8,307.7c-37.8-1.5-70.3-2.9-93.8-4l0-0.5c23.6,1.1,56,2.4,93.8,4L193.8,307.7L193.8,307.7z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_20_"
                filterUnits="userSpaceOnUse"
                x="99.3"
                y="310.7"
                width="95.1"
                height="10.9"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="99.3" y="310.7" width="95.1" height="10.9" id="prefix__P_1_">
              <g class="st43">
                <path id="prefix__O_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z" />
              </g>
            </mask>
            <path class="st44" d="M193.8,321.1c-37.9-4.5-70.4-7.7-93.9-9.3l0-0.5c23.5,1.6,56,4.8,94,9.3L193.8,321.1z" />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_21_"
                filterUnits="userSpaceOnUse"
                x="99.1"
                y="318.7"
                width="95.3"
                height="16.3"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="99.1" y="318.7" width="95.3" height="16.3" id="prefix__R_1_">
              <g class="st45">
                <path id="prefix__Q_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z" />
              </g>
            </mask>
            <path
              class="st46"
              d="M193.8,334.4c-38-5.1-70.5-10.2-94.1-14.6l0.1-0.5c23.5,4.5,56,9.5,94,14.6L193.8,334.4z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_22_"
                filterUnits="userSpaceOnUse"
                x="99"
                y="326.8"
                width="95.5"
                height="21.7"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="99" y="326.8" width="95.5" height="21.7" id="prefix__T_1_">
              <g class="st47">
                <path id="prefix__S_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z" />
              </g>
            </mask>
            <path
              class="st48"
              d="M193.8,347.9c-39.3-8.3-71-15.1-94.2-20l0.1-0.5c23.1,4.9,54.8,11.7,94.2,20L193.8,347.9z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_23_"
                filterUnits="userSpaceOnUse"
                x="98.9"
                y="334.8"
                width="95.6"
                height="27.2"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="98.9" y="334.8" width="95.6" height="27.2" id="prefix__V_1_">
              <g class="st49">
                <path id="prefix__U_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z" />
              </g>
            </mask>
            <path
              class="st50"
              d="M193.8,361.4c-38.1-11.1-70.7-19.9-94.3-25.4l0.1-0.5c23.6,5.6,56.2,14.4,94.3,25.4
        C193.9,360.9,193.8,361.4,193.8,361.4z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_24_"
                filterUnits="userSpaceOnUse"
                x="98.7"
                y="342.9"
                width="95.8"
                height="32.6"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="98.7" y="342.9" width="95.8" height="32.6" id="prefix__X_1_">
              <g class="st51">
                <path id="prefix__W_1_" class="st3" d="M143.1,176.9L97.2,342.7l97.5,30.6l-0.9-228.5L143.1,176.9z" />
              </g>
            </mask>
            <path
              class="st52"
              d="M193.8,374.9c-38.2-11.7-70.8-22.4-94.4-30.9l0.2-0.5c23.6,8.5,56.2,19.2,94.4,30.9L193.8,374.9
        L193.8,374.9z"
            />
          </g>
        </g>
        <path
          class="st1"
          d="M195.6,349.4l0.5-0.2l-0.2-15l-0.5-1.9L195.6,349.4z M192,350.6l0.5-0.2l-0.4-29.8l-0.5-1.9L192,
          350.6zM188.2,351.8l0.5-0.2l-0.6-45.3l-0.5-1.9L188.2,351.8z M184.2,353l0.5-0.2l-0.7-61.6l-0.5-1.9L184.2,
          353z M180,354.3l0.5-0.2l-0.9-78.7l-0.5-1.9L180,354.3z M175.6,355.7l0.5-0.2l-1-96.7l-0.5-1.9L175.6,
          355.7z M170.9,357.2l0.5-0.2l-1.1-115.6l-0.5-1.9L170.9,357.2z M165.9,358.8l0.5-0.2l-1.2-135.5l-0.5-1.9L165.9,
          358.8z M160.6,360.4l0.5-0.2l-1.3-156.5l-0.5-1.9L160.6,360.4zM155,
          362.2l0.5-0.2l-1.4-178.8l-0.3-0.9l-0.2-0.2L155,362.2z M149,364.1l0.5-0.2l-1.2-185.1l-0.5-0.3L149,
          364.1z M142.6,366.1l0.5-0.2L142,174.8l-0.5-0.3L142.6,366.1z M135.8,
          368.2l0.5-0.2l-0.9-197.5l-0.5-0.3L135.8,368.2z M128.4,370.5l0.5-0.2l-0.8-204.3l-0.5-0.3L128.4,
          370.5z M120.6,373l0.5-0.2l-0.5-211.6l-0.5-0.3L120.6,373z M112.1,375.7l0.5-0.2L112.3,156l-0.5-0.3L112.1,
          375.7zM102.9,214.8v163.7l0.5-0.2v-228l-0.2-0.2L102.9,214.8z"
        />
        <g transform="translate(5.308 5.444)">
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_25_"
              filterUnits="userSpaceOnUse"
              x="96.9"
              y="62.7"
              width="93.6"
              height="92.9"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="96.9" y="62.7" width="93.6" height="92.9" id="prefix__ah_1_">
            <g class="st53">
              <path id="prefix__ag_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st54"
            d="M189.4,154.9c-23.2-22-54.9-53.5-91.8-91.1l0.4-0.3c36.9,37.6,68.6,69.2,91.8,91.1L189.4,154.9L189.4,154.9z
        "
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_26_"
              filterUnits="userSpaceOnUse"
              x="97"
              y="75.1"
              width="93.6"
              height="88.2"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="97" y="75.1" width="93.6" height="88.2" id="prefix__aj_1_">
            <g class="st55">
              <path id="prefix__ai_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st56"
            d="M189.6,162.5c-23.2-21.5-55-51.3-91.9-86.4l0.3-0.4c36.9,35,68.7,64.9,91.9,86.4L189.6,162.5L189.6,162.5z"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_27_"
              filterUnits="userSpaceOnUse"
              x="97"
              y="87.5"
              width="93.7"
              height="83.4"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="97" y="87.5" width="93.7" height="83.4" id="prefix__al_1_">
            <g class="st57">
              <path id="prefix__ak_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st58"
            d="M189.7,170.2c-23.2-21-55-49.2-92-81.6l0.3-0.4c37,32.4,68.8,60.6,92,81.6
        C190,169.9,189.7,170.2,189.7,170.2z"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_28_"
              filterUnits="userSpaceOnUse"
              x="97"
              y="100"
              width="93.8"
              height="78.6"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="97" y="100" width="93.8" height="78.6" id="prefix__an_1_">
            <g class="st59">
              <path id="prefix__am_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st60"
            d="M189.8,177.9c-23.2-18.3-55.1-44.9-92.1-76.8l0.3-0.4c37,31.9,68.9,58.5,92.1,76.8L189.8,177.9z"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_29_"
              filterUnits="userSpaceOnUse"
              x="97"
              y="112.6"
              width="93.9"
              height="73.8"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="97" y="112.6" width="93.9" height="73.8" id="prefix__ap_1_">
            <g class="st61">
              <path id="prefix__ao_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st62"
            d="M189.9,185.7c-23.2-17.8-55.1-42.7-92.2-72l0.3-0.4c37.1,29.3,69,54.2,92.2,72L189.9,185.7L189.9,185.7z"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_30_"
              filterUnits="userSpaceOnUse"
              x="97"
              y="125.2"
              width="94"
              height="69"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="97" y="125.2" width="94" height="69" id="prefix__ar_1_">
            <g class="st63">
              <path id="prefix__aq_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st64"
            d="M190,193.4c-23.3-17.4-55.2-40.6-92.3-67.2l0.3-0.4c37.1,26.5,69.1,49.8,92.3,67.2L190,193.4L190,193.4z"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_31_"
              filterUnits="userSpaceOnUse"
              x="97"
              y="137.8"
              width="94.1"
              height="64.1"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="97" y="137.8" width="94.1" height="64.1" id="prefix__at_1_">
            <g class="st65">
              <path id="prefix__as_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st66"
            d="M190.1,201.2c-23.3-14.7-55.2-36.2-92.4-62.3l0.3-0.4c37.2,26.1,69.2,47.6,92.4,62.3L190.1,201.2
        L190.1,201.2z"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_32_"
              filterUnits="userSpaceOnUse"
              x="97"
              y="150.5"
              width="94.2"
              height="59.2"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="97" y="150.5" width="94.2" height="59.2" id="prefix__av_1_">
            <g class="st67">
              <path id="prefix__au_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st68"
            d="M190.2,209c-23.3-14.2-55.3-34.1-92.5-57.4l0.3-0.4c37.2,23.3,69.2,43.2,92.5,57.4L190.2,209L190.2,209z"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_33_"
              filterUnits="userSpaceOnUse"
              x="97"
              y="163.2"
              width="94.3"
              height="54.2"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="97" y="163.2" width="94.3" height="54.2" id="prefix__ax_1_">
            <g class="st69">
              <path id="prefix__aw_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st70"
            d="M190.3,216.8c-23.3-13.7-55.3-31.8-92.6-52.4l0.2-0.4c37.3,20.6,69.3,38.7,92.6,52.4
        C190.6,216.3,190.3,216.8,190.3,216.8z"
          />
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter_34_"
              filterUnits="userSpaceOnUse"
              x="97"
              y="176"
              width="94.3"
              height="49.3"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="97" y="176" width="94.3" height="49.3" id="prefix__az_1_">
            <g class="st71">
              <path id="prefix__ay_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
            </g>
          </mask>
          <path
            class="st72"
            d="M190.5,224.6c-23.3-11-55.4-27.4-92.8-47.5l0.2-0.4c37.3,20.1,69.4,36.5,92.7,47.5
        C190.7,224.1,190.5,224.6,190.5,224.6z"
          />
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_35_"
                filterUnits="userSpaceOnUse"
                x="97.1"
                y="188.8"
                width="94.4"
                height="44.2"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.1" y="188.8" width="94.4" height="44.2" id="prefix__aB_1_">
              <g class="st73">
                <path id="prefix__aA_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
              </g>
            </mask>
            <path
              class="st74"
              d="M190.6,232.4c-23.4-10.5-55.5-25.2-92.9-42.5l0.2-0.5c37.3,17.3,69.4,32,92.8,42.5L190.6,232.4z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_36_"
                filterUnits="userSpaceOnUse"
                x="97.1"
                y="201.7"
                width="94.5"
                height="39.2"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.1" y="201.7" width="94.5" height="39.2" id="prefix__aD_1_">
              <g class="st75">
                <path id="prefix__aC_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
              </g>
            </mask>
            <path
              class="st76"
              d="M190.7,240.3c-23.4-10-55.5-22.9-93-37.4l0.2-0.5c37.5,14.5,69.6,27.5,93,37.4L190.7,240.3L190.7,240.3z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_37_"
                filterUnits="userSpaceOnUse"
                x="97.1"
                y="214.7"
                width="94.5"
                height="34.1"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.1" y="214.7" width="94.5" height="34.1" id="prefix__aF_1_">
              <g class="st77">
                <path id="prefix__aE_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
              </g>
            </mask>
            <path
              class="st78"
              d="M190.8,248.2c-23.4-7.2-55.6-18.4-93.1-32.4l0.2-0.5c37.5,14,69.7,25.2,93.1,32.4L190.8,248.2L190.8,248.2z
        "
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_38_"
                filterUnits="userSpaceOnUse"
                x="97.1"
                y="227.7"
                width="94.6"
                height="29"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.1" y="227.7" width="94.6" height="29" id="prefix__aH_1_">
              <g class="st79">
                <path id="prefix__aG_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
              </g>
            </mask>
            <path
              class="st80"
              d="M190.9,256c-23.4-6.7-55.6-16.1-93.2-27.3l0.1-0.5c37.6,11.2,69.8,20.6,93.2,27.3
        C191.1,255.6,190.9,256,190.9,256z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_39_"
                filterUnits="userSpaceOnUse"
                x="97.2"
                y="240.7"
                width="94.6"
                height="23.8"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.2" y="240.7" width="94.6" height="23.8" id="prefix__aJ_1_">
              <g class="st81">
                <path id="prefix__aI_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
              </g>
            </mask>
            <path
              class="st82"
              d="M191.1,263.9c-23.4-6.2-55.7-13.8-93.3-22.1l0.1-0.5c37.6,8.3,69.9,16,93.3,22.2L191.1,263.9z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_40_"
                filterUnits="userSpaceOnUse"
                x="97.2"
                y="253.8"
                width="94.6"
                height="18.6"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.2" y="253.8" width="94.6" height="18.6" id="prefix__aL_1_">
              <g class="st83">
                <path id="prefix__aK_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
              </g>
            </mask>
            <path
              class="st84"
              d="M191.2,271.9c-23.4-3.4-55.7-9.3-93.4-17l0.1-0.5c37.7,7.7,70,13.6,93.4,17
        C191.3,271.4,191.2,271.9,191.2,271.9z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_41_"
                filterUnits="userSpaceOnUse"
                x="97.2"
                y="267"
                width="94.7"
                height="13.4"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.2" y="267" width="94.7" height="13.4" id="prefix__aN_1_">
              <g class="st85">
                <path id="prefix__aM_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
              </g>
            </mask>
            <path
              class="st86"
              d="M191.3,279.8c-23.5-2.9-55.8-6.9-93.5-11.8l0.1-0.5c37.7,4.9,70,8.9,93.5,11.8
        C191.4,279.3,191.3,279.8,191.3,279.8z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_42_"
                filterUnits="userSpaceOnUse"
                x="97.3"
                y="280.2"
                width="94.7"
                height="8.1"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.3" y="280.2" width="94.7" height="8.1" id="prefix__aP_1_">
              <g class="st87">
                <path id="prefix__aO_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1L97,373.3z" />
              </g>
            </mask>
            <path
              class="st88"
              d="M191.4,287.8c-23.5-2.3-55.8-4.6-93.6-6.6l0-0.5c37.8,2,70.2,4.3,93.6,6.6L191.4,287.8L191.4,287.8z"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_43_"
                filterUnits="userSpaceOnUse"
                x="97.3"
                y="293.4"
                width="94.8"
                height="3"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.3" y="293.4" width="94.8" height="3" id="prefix__aR_1_">
              <g class="st89">
                <path id="prefix__aQ_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1" />
              </g>
            </mask>
            <path
              class="st90"
              d="M170.9,296c-20.5,0-45.3-0.5-73.1-1.5l0-0.5c37.8,1.4,70.2,1.8,93.7,1.3l0,0.5
        C185.3,295.9,178.4,296,170.9,296"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_44_"
                filterUnits="userSpaceOnUse"
                x="97.3"
                y="302.7"
                width="94.9"
                height="5.5"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.3" y="302.7" width="94.9" height="5.5" id="prefix__aT_1_">
              <g class="st91">
                <path id="prefix__aS_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1" />
              </g>
            </mask>
            <path
              class="st92"
              d="M97.8,307.7l0-0.5c37.8-1.5,70.2-2.9,93.8-4l0,0.5C168.1,304.8,135.6,306.2,97.8,307.7"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_45_"
                filterUnits="userSpaceOnUse"
                x="97.2"
                y="310.7"
                width="95.1"
                height="10.8"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.2" y="310.7" width="95.1" height="10.8" id="prefix__aV_1_">
              <g class="st93">
                <path id="prefix__aU_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1" />
              </g>
            </mask>
            <path
              class="st94"
              d="M97.9,321.1l-0.1-0.5c37.9-4.5,70.4-7.7,94-9.3l0,0.5C168.2,313.4,135.8,316.6,97.9,321.1"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_46_"
                filterUnits="userSpaceOnUse"
                x="97.2"
                y="318.7"
                width="95.3"
                height="16.2"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.2" y="318.7" width="95.3" height="16.2" id="prefix__aX_1_">
              <g class="st95">
                <path id="prefix__aW_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1" />
              </g>
            </mask>
            <path
              class="st96"
              d="M97.9,334.4l-0.1-0.5c38-5.1,70.5-10.2,94-14.6l0.1,0.5C168.4,324.3,135.9,329.3,97.9,334.4"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_47_"
                filterUnits="userSpaceOnUse"
                x="97.2"
                y="326.8"
                width="95.5"
                height="21.6"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.2" y="326.8" width="95.5" height="21.6" id="prefix__aZ_1_">
              <g class="st97">
                <path id="prefix__aY_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1" />
              </g>
            </mask>
            <path
              class="st98"
              d="M97.9,347.9l-0.1-0.5c38.8-8.2,71.3-15.1,94.2-20l0.1,0.5C169.2,332.7,136.6,339.7,97.9,347.9"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_48_"
                filterUnits="userSpaceOnUse"
                x="97.1"
                y="334.8"
                width="95.6"
                height="27"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.1" y="334.8" width="95.6" height="27" id="prefix__bb_1_">
              <g class="st99">
                <path id="prefix__ba_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1" />
              </g>
            </mask>
            <path
              class="st100"
              d="M97.9,361.4l-0.1-0.5c38.1-11.1,70.7-19.9,94.3-25.4l0.1,0.5C168.6,341.5,136,350.3,97.9,361.4"
            />
          </g>
          <g>
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_49_"
                filterUnits="userSpaceOnUse"
                x="97.1"
                y="342.9"
                width="95.8"
                height="32.5"
              >
                <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
              </filter>
            </defs>
            <mask maskUnits="userSpaceOnUse" x="97.1" y="342.9" width="95.8" height="32.5" id="prefix__bd_1_">
              <g class="st101">
                <path id="prefix__bc_1_" class="st3" d="M97,373.3l97.5-30.6l-45.9-165.8l-50.8-32.1" />
              </g>
            </mask>
            <path
              class="st102"
              d="M97.9,374.9l-0.1-0.5c38.2-11.7,70.8-22.4,94.4-30.9l0.2,0.5C168.7,352.5,136.1,363.2,97.9,374.9"
            />
          </g>
        </g>
        <line class="st103" x1="-2.5" y1="382.4" x2="897.5" y2="382.4" />
        <g>
          <path
            class="st1"
            d="M196.4,348.2c-6.6-26.3-14.3-52.7-21.8-78.3c-5.6-19.1-11.3-39-16.6-58.6c-6.7-24.9-17.9-32.6-32.2-42.2
        c-7-4.8-15-10.2-23.5-18.5l0.4-0.4c8.5,8.3,16.4,13.7,23.4,18.5c14.3,9.7,25.6,17.4,32.4,42.6c5.3,19.6,11,
        39.4,16.6,58.5c7.4,25.6,15.1,52,21.8,78.3C196.9,348.1,196.4,348.2,196.4,348.2z"
          />
          <path
            class="st1"
            d="M205.9,348.2c-6.1-25.6-13.4-51.4-20.4-76.3c-5.6-19.8-11.3-40.2-16.5-60.5c-6.2-24.3-16.9-31.8-30.5-41.2
            c-7.2-5-15.3-10.6-23.9-19.7l0.4-0.4c8.5,9,16.6,14.6,23.8,19.6c13.7,9.5,24.5,17,30.7,41.5c5.2,20.3,10.9,
            40.7,16.5,60.5c7,24.9,14.3,50.7,20.4,76.3L205.9,348.2L205.9,348.2z"
          />
          <path
            class="st1"
            d="M215.5,348.2c-5.7-25.2-12.6-50.5-19.3-74.9c-5.5-20.2-11.2-41-16.2-61.8c-5.7-23.8-16-31.1-29.1-40.3
            c-7.3-5.1-15.6-11-24-20.7l0.4-0.4c8.4,9.7,16.7,15.5,23.9,20.6c13.1,9.2,23.5,16.5,29.3,40.6c5,20.7,10.7,
            41.6,16.2,61.8c6.7,24.5,13.6,49.7,19.3,75L215.5,348.2z"
          />
          <path
            class="st1"
            d="M225.1,348.2c-5.2-24.9-11.8-49.9-18.2-74c-5.4-20.4-11-41.6-15.8-62.6c-5.3-23.4-15.7-30.8-27.7-39.4
            c-7.4-5.3-15.7-11.2-24-21.6l0.4-0.3c8.3,10.3,16.6,16.3,23.9,21.5c12.1,8.7,22.6,16.2,27.9,39.8c4.7,21,10.3,
            42.1,15.8,62.6c6.4,24.1,13,49.1,18.3,74L225.1,348.2L225.1,348.2z"
          />
          <path
            class="st1"
            d="M234.6,348.2c-4.8-24.7-11.2-49.5-17.3-73.4c-5.3-20.6-10.8-41.9-15.2-63.1c-4.9-23-14.9-30.3-26.5-38.7
            c-7.4-5.4-15.8-11.4-23.9-22.5l0.4-0.3c8.1,10.9,16.4,17,23.8,22.3c11.7,8.5,21.9,15.8,26.8,39c4.5,21.2,9.9,
            42.5,15.2,63.1c6.1,23.9,12.5,48.6,17.3,73.4L234.6,348.2L234.6,348.2z"
          />
          <path
            class="st1"
            d="M244.2,348.2c-4.4-24.6-10.5-49.2-16.4-72.9c-5.1-20.7-10.5-42.1-14.7-63.5c-4.4-22.6-14.2-29.7-25.5-38
            c-7.4-5.5-15.9-11.6-23.7-23.2l0.5-0.3c7.8,11.5,16.2,17.7,23.6,23.1c11.4,8.3,21.2,15.5,25.7,38.4c4.2,21.4,
            9.5,42.8,14.7,63.5c5.9,23.8,12,48.3,16.4,72.9L244.2,348.2L244.2,348.2z"
          />
          <path
            class="st1"
            d="M253.7,348.2c-4.1-24.5-9.9-48.9-15.6-72.5c-5-20.8-10.1-42.3-14.1-63.8c-4.1-22.2-13.5-29.3-24.5-37.4
            c-7.4-5.5-15.9-11.8-23.4-23.9l0.5-0.3c7.4,12,15.5,18,23.2,23.8c11,8.2,20.6,15.3,24.7,37.8c3.9,21.5,9.1,43,
            14.1,63.7c5.7,23.6,11.5,48,15.6,72.6L253.7,348.2L253.7,348.2z"
          />
          <path
            class="st1"
            d="M263.3,348.2c-3.7-24.4-9.3-48.7-14.8-72.2c-4.8-20.8-9.8-42.4-13.4-64c-3.7-21.9-12.9-28.8-23.5-36.9
            c-7.8-5.9-15.9-12-23-24.6l0.5-0.3c7.1,12.5,15.1,18.6,22.8,24.4c10.8,8.1,20,15.1,23.8,37.2c3.6,21.6,8.6,
            43.1,13.4,63.9c5.4,23.5,11.1,47.8,14.8,72.3L263.3,348.2L263.3,348.2z"
          />
          <path
            class="st1"
            d="M272.8,348.2c-3.3-24.3-8.7-48.5-13.9-71.9c-4.7-20.9-9.5-42.5-12.8-64.2c-3.3-21.6-12.3-28.4-22.7-36.4
            c-7.8-5.9-15.8-12.1-22.5-25.2l0.5-0.2c6.6,13,14.6,19.1,22.4,25c10.1,7.7,19.6,14.9,22.9,36.7c3.3,21.7,8.2,
            43.3,12.8,64.2c5.2,23.4,10.6,47.6,13.9,71.9L272.8,348.2L272.8,348.2z"
          />
          <path
            class="st1"
            d="M282.4,348.2c-3-24.3-8.1-48.3-13.1-71.6c-4.5-21-9.2-42.7-12.2-64.5c-3-21.2-12.2-28.4-21.9-35.9
            c-7.8-6-15.8-12.2-22-25.7l0.5-0.2c6.2,13.4,14.1,19.5,21.8,25.5c9.8,7.6,19.1,14.8,22.1,36.3c3,21.8,7.7,
            43.5,12.2,64.4c5,23.3,10.2,47.3,13.1,71.6L282.4,348.2L282.4,348.2z"
          />
          <path
            class="st1"
            d="M292,348.2c-2.6-24-7.5-47.8-12.3-70.8c-4.4-21.2-8.9-43.2-11.6-65.2c-2.6-20.9-11.6-28-21.1-35.5
            c-7.7-6.1-15.7-12.3-21.4-26.2l0.5-0.2c5.7,13.7,13.6,19.9,21.3,25.9c9.6,7.6,18.7,14.7,21.3,35.8c2.7,22.1,
            7.3,44,11.6,65.2c4.7,23,9.6,46.8,12.3,70.8L292,348.2L292,348.2z"
          />
          <path
            class="st1"
            d="M301.5,348.2c-2.4-23.5-7-46.9-11.4-69.5c-4.2-21.6-8.6-44-11.1-66.5c-2.3-20.6-11.1-27.6-20.4-35.1
            c-7.7-6.1-15.6-12.5-20.8-26.6l0.5-0.2c5.1,14,13,20.3,20.6,26.4c9.4,7.5,18.3,14.6,20.6,35.4c2.5,22.5,6.8,
            44.8,11.1,66.5c4.4,22.6,9,46,11.4,69.5L301.5,348.2z"
          />
          <path
            class="st1"
            d="M311.1,348.2c-2.2-23.6-6.5-47.1-10.7-69.9c-3.9-21.5-8-43.8-10.3-66.1c-2.1-20.1-10.7-27.2-19.8-34.6
            c-7.6-6.2-15.5-12.6-20.2-27l0.5-0.2c4.6,14.2,12.4,20.6,20,26.8c9.2,7.5,17.9,14.6,20,35c2.3,22.3,6.4,44.6,
            10.3,66.1c4.1,22.7,8.4,46.3,10.7,69.9L311.1,348.2z"
          />
          <path
            class="st1"
            d="M320.6,348.2c-2-23.7-6-47.3-9.9-70.1c-3.6-21.5-7.4-43.7-9.5-65.9c-1.9-20-10.4-27-19.3-34.5
            c-7.5-6.2-15.2-12.7-19.5-27.1l0.5-0.2c4.2,14.3,11.9,20.7,19.3,26.9c9,7.5,17.5,14.6,19.5,34.8c2.1,22.2,5.9,
            44.4,9.5,65.8c3.9,22.9,7.8,46.5,9.9,70.2L320.6,348.2z"
          />
          <path
            class="st1"
            d="M330.2,348.2c-1.7-22.4-5.3-44.8-8.8-66.4c-3.1-19.4-6.3-39.4-8.2-59.4c-2.3-24.3-3.8-28.7-16.2-45.9
            c-10.8-5.4-18-14.1-21.5-25.9l0.5-0.2c3.4,11.7,10.6,20.3,21.3,25.6l0.1,0.1c12.4,17.2,14.1,22,16.4,46.3c1.9,
            20,5.1,40,8.2,59.3c3.5,21.6,7.1,44,8.8,66.4L330.2,348.2L330.2,348.2z"
          />
          <path
            class="st1"
            d="M339.7,348.2c-1.6-22.4-4.9-44.8-8.1-66.4c-2.8-19.4-5.8-39.4-7.5-59.4c-2-23-3.3-28.5-15-46
            c-10.4-5.5-17.1-14.2-20.1-25.8l0.5-0.1c3,11.5,9.7,20.1,19.9,25.5l0.1,0.1c11.2,16.7,13.1,22.4,15.1,
            46.3c1.7,20,4.7,40,7.5,59.4c3.2,21.7,6.5,44.1,8.1,66.5L339.7,348.2L339.7,348.2z"
          />
          <path
            class="st1"
            d="M349.3,348.2c-1.4-22.3-4.4-44.8-7.3-66.4c-2.6-19.4-5.3-39.5-6.8-59.5c-1.7-22.1-3.2-29-13.5-46
            c-9.8-5.6-16-14.3-18.4-25.7l0.5-0.1c2.4,11.3,8.5,19.9,18.2,25.4l0.1,0l0,0.1c10.5,17.1,11.9,24.1,13.6,46.3
            c1.5,20,4.2,40.1,6.8,59.5c2.9,21.7,5.9,44.1,7.3,66.5L349.3,348.2L349.3,348.2z"
          />
          <path
            class="st1"
            d="M358.9,348.2c-1.3-22.3-3.9-44.6-6.5-66.3c-2.3-19.5-4.7-39.7-6.1-59.8c-1.5-21.6-3.1-29.7-12-45.9
            c-9.1-5.8-14.7-14.5-16.4-25.6l0.5-0.1c1.7,11,7.2,19.5,16.2,25.3l0.1,0.1c8.9,16.4,10.6,24.6,12.1,46.2c1.4,
            20,3.8,40.2,6.1,59.8c2.6,21.7,5.2,44.1,6.5,66.3L358.9,348.2L358.9,348.2z"
          />
          <path
            class="st1"
            d="M368.4,348.2c-1.1-22.2-3.5-44.5-5.7-66.1c-2.1-19.7-4.2-40-5.4-60.1c-1.2-19.6-2.4-29.2-10.3-45.9
            c-8.3-6.1-13.1-14.7-14.2-25.5l0.5-0.1c1.1,10.6,5.8,19.1,14,25.1l0.1,0.1c7.9,16.8,9.2,26.5,10.4,46.2
            c1.2,20.1,3.3,40.4,5.4,60.1c2.3,21.6,4.6,44,5.7,66.1L368.4,348.2L368.4,348.2z M378,348.2c-1-22-3-44.3-5-65.8
            c-1.8-19.8-3.7-40.3-4.7-60.6c-1-19.6-2.4-30.3-8.6-45.9c-7.4-6.5-11.4-15-11.9-25.4l0.5,0c0.4,10.2,4.4,18.6,
            11.7,25l0.1,0.1c6.2,15.8,7.6,26.5,8.6,46.1c1,20.3,2.9,40.8,4.7,60.6c2,21.5,4,43.8,5,65.8L378,348.2L378,
            348.2z M387.5,348.2c-0.8-21.8-2.5-44-4.2-65.3c-1.5-20-3.1-40.7-4-61.2c-0.8-18.5-2.1-30.7-6.9-45.9
            c-6.4-6.9-9.6-15.4-9.5-25.2l0.5,0c-0.1,9.8,3.1,18.1,9.4,24.9l0.1,0.1c4.8,15.3,6.1,27.5,6.9,46.1c0.9,20.4,
            2.5,41.1,4,61.1c1.6,21.4,3.3,43.5,4.2,65.4L387.5,348.2L387.5,348.2z M397.1,
            348.2c-0.7-21.6-2.1-43.6-3.4-64.8c-1.3-20.3-2.6-41.2-3.3-61.8c-0.5-14.8-1.3-29.5-5.2-45.9
            c-5.3-7.3-7.7-15.7-7.2-25.1l0.5,0c-0.5,9.3,1.9,17.6,7.1,24.8l0,0.1c4,16.5,4.8,31.2,5.3,46.1c0.7,
            20.6,2,41.6,3.3,61.8c1.3,21.2,2.7,43.2,3.4,64.8L397.1,348.2L397.1,348.2z M406.7,348.2
            c-0.5-21.4-1.6-43.1-2.6-64.1c-1-20.5-2.1-41.8-2.6-62.7c-0.3-9.8-2.4-20.9-4.4-31.6
            c-2.6-13.5-5.3-27.4-4.4-39.4l0.5,0c-0.9,11.9,1.8,25.8,4.3,39.2c2.1,10.7,4.2,21.8,4.4,31.6c0.6,20.9,1.6,
            42.1,2.6,62.6c1,21,2.1,42.7,2.6,64.1L406.7,348.2L406.7,348.2z M416.2,348.2c-0.4-21.1-1.1-42.5-1.9-63.3
            c-0.7-20.8-1.5-42.4-1.9-63.6c-0.2-9.5-1.5-19.9-2.8-30c-1.8-13.8-3.7-28.1-2.7-40.8l0.5,0c-1,12.7,0.9,26.9,
            2.7,40.7c1.3,10.1,2.7,20.5,2.8,30.1c0.4,21.2,1.1,42.7,1.9,63.5c0.7,20.7,1.5,42.2,1.9,63.3L416.2,
            348.2L416.2,348.2z M425.8,348.2c-0.3-24.8-1.6-50.5-3-75.4c-2.1-40.4-4.3-82.2-2.1-122.3l0.5,0c-2.2,40,0,
            81.8,2.1,122.2c1.3,24.9,2.7,50.6,3,75.4L425.8,348.2L425.8,348.2z M435.3,348.2c-0.1-24.4-0.5-49.3-0.9-73.3
            c-0.7-40.8-1.4-83-0.6-124.3l0.5,0c-0.9,41.4-0.1,83.5,0.6,124.3c0.4,24,0.8,48.9,0.9,73.3L435.3,
            348.2z M445.4,348.2h-0.5c0.1-25.9,0.5-52.3,0.8-77.8c0.6-39.3,1.2-79.9,0.7-119.8l0.5,0
            c0.5,39.9-0.1,80.5-0.7,119.8C445.9,295.8,445.5,322.2,445.4,348.2 M455,348.2l-0.5,0c0.2-26.9,1.5-54.6,
            2.7-81.3c1.7-38.3,3.5-77.9,2.4-116.3l0.5,0c1.1,38.5-0.7,78.1-2.4,116.4C456.5,293.6,455.2,321.2,455,
            348.2 M464.6,348.2l-0.5,0c0.4-28.6,2.6-58.1,4.6-86.6c2.7-36.7,5.4-74.6,4.6-111l0.5,0c0.8,36.4-1.9,74.3-4.6,
            111C467.1,290.1,465,319.6,464.6,348.2M474.1,348.2l-0.5,0c0.4-19.9,1.6-40.1,2.7-59.7c1.3-22.2,2.6-45.2,
            2.9-67.9c0.1-12.2,2.2-24.2,4.3-35.8c2.1-11.8,4-22.9,4.1-34.3l0.5,0c-0.1,11.5-2.1,23.1-4.1,34.4c-2,11.6-4.1,
            23.5-4.2,35.7c-0.2,22.7-1.6,45.7-2.9,67.9C475.7,308,474.5,328.2,474.1,348.2 M484.2,324c0.7-12,1.6-23.9,
            2.4-35.6c1.7-22.2,3.4-45.2,3.7-67.9c-0.2-13.3,0.3-26.8,1.6-40.1c1-5.1,3-9,4.9-12.8c2.4-4.8,4.9-9.7,
            5.4-17l0.5,0c-0.5,7.4-3,12.4-5.4,17.2c-1.9,3.7-3.9,7.6-4.8,12.6c-1.3,13.2-1.8,26.7-1.6,40c-0.3,22.8-2,
            45.7-3.7,68c-1.5,19.6-3,39.8-3.5,59.8 M483.7,348.2l-0.5,0c0.2-8,0.6-16.1,1.1-24.2 M493.2,348.2l-0.5,0
            c0.7-20.1,2.5-40.4,4.3-59.9c2-22.2,4.1-45.2,4.5-68c-0.4-13.3,0.3-26.7,2.1-39.9c1.4-5.4,3.9-9.3,6.4-13.2
            c3-4.6,6-9.4,7.1-16.6l0.5,0.1c-1.1,7.4-4.2,12.2-7.2,16.9c-2.4,3.8-5,7.7-6.3,13c-1.7,13.1-2.4,26.6-2.1,39.8
            c-0.4,22.8-2.5,45.8-4.5,68.1C495.7,307.8,493.9,328.1,493.2,348.2 M502.8,348.2l-0.5,0c0.8-20.2,3-40.5,
            5.1-60.1c2.4-22.2,4.8-45.2,5.3-68.1c-0.5-13.3,0.4-26.7,2.6-39.8c1.7-5.6,4.9-9.7,8-13.7c3.5-4.5,7.1-9.2,
            8.8-16.1l0.5,0.1c-1.7,7.1-5.4,11.8-8.9,16.3c-3.2,4.1-6.2,8-7.9,13.5c-2.2,13-3.1,26.4-2.6,
            39.7c-0.5,22.9-2.9,45.9-5.3,68.1C505.7,307.7,503.6,328,502.8,348.2"
          />
          <path
            class="st1"
            d="M512.3,348.2l-0.5,0c0.9-20.3,3.4-40.6,5.8-60.2c2.7-22.2,5.6-45.2,6.1-68.1c-0.6-13.3,0.5-26.6,3.2-39.6
        c2.6-5.3,6-9.3,9.3-13.1c4.1-4.7,8.3-9.5,10.8-16.7l0.5,0.2c-2.5,7.3-6.8,12.2-10.9,16.9c-3.3,3.8-6.7,7.7-9.2,12.9
        c-2.7,12.9-3.7,26.2-3.1,39.4c-0.5,23-3.4,46-6.1,68.2C515.8,307.6,513.3,327.9,512.3,348.2"
          />
          <path
            class="st1"
            d="M521.9,348.2l-0.5,0c1-20.4,3.9-40.7,6.6-60.4c3.1-22.2,6.3-45.2,6.9-68.2c-0.7-13.3,0.6-26.6,3.7-39.5
        c3-5.7,7.1-9.9,11.1-13.9c4.5-4.5,9.1-9.2,12.1-15.9l0.5,0.2c-3.1,6.7-7.8,11.5-12.2,16c-4,4-8.1,8.2-11,13.8
        c-3.1,12.8-4.4,26-3.7,39.3c-0.6,23-3.8,46-6.9,68.2C525.8,307.5,522.9,327.8,521.9,348.2"
          />
          <path
            class="st1"
            d="M531.5,348.2l-0.5,0c1.2-20.5,4.3-40.8,7.4-60.5c3.5-22.2,7-45.1,7.7-68.2c-0.8-13.3,0.6-26.5,4.2-39.3
        c3.4-6,8.3-10.6,13.1-14.9c4.7-4.4,9.7-8.9,13.1-14.9l0.5,0.3c-3.5,6.1-8.5,10.6-13.3,15c-4.9,4.5-9.6,8.8-12.9,14.7
        c-3.5,12.7-4.9,25.9-4.2,39.1c-0.7,23.1-4.3,46.1-7.7,68.3C535.8,307.4,532.6,327.7,531.5,348.2"
          />
          <path
            class="st1"
            d="M541,348.2l-0.5,0c1.3-20.6,4.8-41,8.2-60.7c3.8-22.2,7.8-45.1,8.5-68.3c1-29.2,7.8-37.3,19.1-50.7
        c4.2-5,8.9-10.6,14.3-18.2l0.4,0.3c-5.4,7.7-10.1,13.3-14.3,18.3c-11.3,13.3-18.1,21.4-19,50.4c-0.8,23.2-4.7,
        46.1-8.5,68.3C545.8,307.2,542.3,327.6,541,348.2"
          />
          <path
            class="st1"
            d="M550.6,348.2l-0.5,0c1.4-20.7,5.3-41.1,9-60.8c4.2-22.2,8.5-45.1,9.3-68.3c1.1-30.6,8.5-38.6,21.9-53
        c4.1-4.4,8.7-9.4,14-15.8l0.4,0.3c-5.2,6.4-9.9,11.4-14,15.9c-13.3,14.3-20.7,22.2-21.8,52.6c-0.8,23.3-5.2,
        46.2-9.3,68.4C555.8,307.1,552,327.5,550.6,348.2"
          />
          <path
            class="st1"
            d="M560.1,348.2l-0.5,0c1.7-21.9,6-43.1,10.2-63.6c3.7-18.4,7.6-37.5,9.6-56.9c0.5-5,0.5-10.2,0.5-15.2
        c-0.1-12.1-0.1-24.6,7.3-35.5c4.1-6,10.3-10.5,16.2-14.9c4.9-3.6,10-7.3,13.9-11.8l0.4,0.4c-4,4.6-9.1,8.3-14,11.9
        c-5.9,4.3-12,8.8-16.1,14.7c-7.4,10.8-7.3,23.2-7.2,35.2c0,5,0.1,10.2-0.5,15.3c-1.9,19.4-5.8,38.5-9.6,56.9
        C566.1,305.1,561.8,326.3,560.1,348.2"
          />
          <path
            class="st1"
            d="M569.7,348.2l-0.5,0c1.8-22,6.5-43.3,11-63.8c4-18.4,8.2-37.5,10.3-57c0.5-5.1,0.5-10.3,0.5-15.3
        c0-12,0-24.4,7.6-35.3c4.3-6.2,10.7-10.7,17-15.1c4.9-3.5,10-7.1,14-11.4l0.4,0.4c-4,4.4-9.2,8-14.1,11.5
        c-6.2,4.4-12.6,8.9-16.8,15c-7.5,10.8-7.5,22.5-7.5,35c0,5,0,10.3-0.5,15.3c-2.1,19.5-6.3,38.6-10.3,57
        C576.2,305,571.5,326.2,569.7,348.2"
          />
          <path
            class="st1"
            d="M579.2,348.2l-0.5,0c2-22.2,7-43.4,11.8-64c4.3-18.4,8.8-37.5,11.1-57.1c0.6-5.1,0.6-10.3,0.7-15.3
        c0.1-12.2,0.2-23.8,7.9-34.8c4.3-6.2,10.9-10.8,17.3-15.2c5.1-3.5,10.3-7.2,14.4-11.6l0.4,0.4c-4.1,4.5-9.4,
        8.1-14.5,11.7c-6.3,4.4-12.9,9-17.2,15.1c-7.7,10.8-7.7,22.3-7.8,34.5c0,5-0.1,10.2-0.7,15.3c-2.3,19.6-6.8,
        38.7-11.1,57.2C586.2,304.8,581.2,326,579.2,348.2"
          />
          <path
            class="st1"
            d="M588.8,348.2l-0.5-0.1c2.1-22.5,7.3-43.9,12.4-64.6c4.4-18.1,9-36.8,11.4-56.2c0.6-5,0.8-10.1,0.9-14.9
        c0.4-12.4,0.7-24,8.8-35.1c4.5-6.2,11.2-10.8,17.7-15.3c5.2-3.6,10.5-7.3,14.7-11.8l0.4,0.4c-4.2,4.5-9.6,8.2-14.8,
        11.8c-6.5,4.5-13.1,9.1-17.5,15.2c-7.9,11-8.3,22.6-8.7,34.8c-0.1,4.9-0.3,9.9-1,15c-2.5,19.4-7,38.1-11.5,56.2
        C596.1,304.3,590.9,325.8,588.8,348.2"
          />
          <path
            class="st1"
            d="M598.4,348.2l-0.5-0.1c2.4-22.6,7.8-44.3,13-65.2c4.5-17.8,9-36.3,11.8-55.3c0.7-5,1-9.9,1.2-14.7
        c0.7-12.4,1.3-24.2,9.6-35.4c4.6-6.2,11.4-10.9,18-15.4c5.3-3.7,10.8-7.4,15.1-12l0.4,0.4c-4.3,4.5-9.8,8.3-15.1,12
        c-6.6,4.5-13.3,9.2-17.8,15.3c-8.2,11.1-8.8,22.8-9.5,35.1c-0.3,4.8-0.5,9.7-1.2,14.7c-2.7,19-7.3,37.5-11.8,55.3
        C606.1,303.9,600.7,325.6,598.4,348.2"
          />
          <path
            class="st1"
            d="M607.9,348.2l-0.5-0.1c2.7-22.6,8.3-44.4,13.6-65.5c4.5-17.7,9.1-36,12.1-54.7c0.8-4.9,1.2-9.7,1.5-14.4
            c1-12.5,1.9-24.4,10.5-35.7c4.7-6.1,11.6-10.9,18.3-15.5c5.4-3.7,11-7.6,15.4-12.1l0.4,0.4c-4.4,4.6-10,
            8.5-15.5,12.2c-6.7,4.6-13.6,9.3-18.2,15.4c-8.5,11.2-9.4,23-10.4,35.4c-0.4,4.7-0.7,9.5-1.5,14.4c-3,
            18.8-7.6,37.1-12.1,54.8C616.2,303.8,610.6,325.6,607.9,348.2"
          />
          <path
            class="st1"
            d="M617.5,348.2l-0.5-0.1c3.1-22.7,8.8-44.6,14.2-65.8c4.5-17.5,9.2-35.6,12.4-54.1c0.8-4.8,1.3-9.5,1.8-14.1
            c1.3-12.6,2.5-24.6,11.4-36.1c4.8-6.1,11.8-10.9,18.6-15.6c5.6-3.8,11.3-7.7,15.8-12.3l0.4,0.4c-4.5,4.7-10.3,
            8.6-15.9,12.4c-6.8,4.6-13.8,9.4-18.5,15.5c-8.8,11.4-10,23.2-11.3,35.8c-0.5,4.5-0.9,9.2-1.8,14.1c-3.2,
            18.5-7.9,36.6-12.4,54.2C626.2,303.6,620.5,325.5,617.5,348.2"
          />
          <path
            class="st1"
            d="M627,348.2l-0.5-0.1c3.4-22.7,9.3-44.8,14.9-66.2c4.6-17.3,9.3-35.2,12.7-53.4c0.9-4.7,1.5-9.3,2-13.7
            c1.6-12.8,3.1-24.8,12.3-36.4c4.9-6.1,12-11,18.9-15.7c5.7-3.9,11.6-7.8,16.1-12.5l0.4,0.4c-4.6,4.7-10.5,
            8.7-16.2,12.6c-6.9,4.7-14,9.5-18.8,15.5c-9.1,11.5-10.6,22.9-12.2,36.2c-0.5,4.4-1.1,9-2,13.7c-3.4,
            18.2-8.2,36.1-12.7,53.5C636.3,303.4,630.5,325.5,627,348.2"
          />
          <path
            class="st1"
            d="M636.6,348.2l-0.5-0.1c3.8-22.8,9.8-45.1,15.6-66.6c4.6-17.1,9.4-34.8,13-52.7c0.9-4.6,1.6-9,2.2-13.2
            c2-13.5,3.7-25.1,13.3-36.9c5-6.1,12.2-11,19.2-15.7c5.8-3.9,11.8-8,16.5-12.7l0.4,0.4c-4.7,4.8-10.8,8.9-16.6,
            12.8c-7,4.7-14.1,9.6-19.1,15.6c-9.5,11.7-11.2,23.2-13.2,36.6c-0.6,4.3-1.3,8.7-2.2,13.3c-3.6,17.9-8.4,
            35.6-13,52.7C646.4,303.1,640.4,325.4,636.6,348.2"
          />
          <path
            class="st1"
            d="M646.2,348.2l-0.5-0.1c4.2-22.9,10.3-45.4,16.3-67.2c4.6-16.9,9.4-34.3,13.2-51.9c1-4.4,1.7-8.7,2.4-12.8
            c2.3-13.6,4.3-25.4,14.3-37.4c5.1-6.1,12.4-11,19.5-15.8c5.9-4,12.1-8.1,16.9-13l0.4,0.4c-4.8,4.9-11,9-17,13
            c-7,4.7-14.3,9.6-19.4,15.7c-9.9,11.9-11.9,23.6-14.1,37.1c-0.7,4.1-1.4,8.3-2.4,12.8c-3.8,17.6-8.6,35-13.2,
            51.9C656.5,302.8,650.3,325.3,646.2,348.2"
          />
          <path
            class="st1"
            d="M655.7,348.2l-0.5-0.1c4.5-23.1,10.9-45.9,17.1-67.9c4.6-16.6,9.4-33.7,13.4-50.8c1-4.3,1.8-8.3,2.5-12.2
            c2.6-13.8,4.9-25.8,15.3-38c5.2-6.1,12.6-11.1,19.7-15.8c6.1-4.1,12.4-8.3,17.3-13.2l0.4,0.4c-5,4.9-11.3,
            9.2-17.4,13.2c-7.1,4.8-14.5,9.7-19.6,15.7c-10.3,12.1-12.5,24-15.2,37.7c-0.7,3.9-1.5,8-2.5,12.2c-4,17.2-8.8,
            34.3-13.4,50.9C666.6,302.3,660.2,325.1,655.7,348.2"
          />
          <path
            class="st1"
            d="M665.3,348.2l-0.5-0.1c4.5-21.4,10.6-42.5,16.5-62.9c5.2-18.1,10.6-36.8,14.9-55.5c0.8-3.4,1.4-6.6,2.1-9.7
            c3.2-15.4,5.7-27.6,16.9-40.5c5.3-6.1,12.8-11.1,20-15.9c6.2-4.1,12.6-8.4,17.7-13.4l0.4,0.4c-5.1,5-11.5,
            9.3-17.8,13.5c-7.2,4.8-14.6,9.7-19.9,15.8c-11.1,12.7-13.6,24.9-16.8,40.2c-0.6,3.1-1.3,6.3-2.1,9.7c-4.3,
            18.8-9.7,37.5-14.9,55.6C675.9,305.7,669.8,326.9,665.3,348.2"
          />
          <path
            class="st1"
            d="M674.8,348.2l-0.5-0.1c4.9-21.7,11.2-43.1,17.3-63.9c5.2-17.7,10.6-36,15-54.2c0.8-3.2,1.5-6.2,2.1-9.1
            c3.5-15.6,6.3-28,18-41c5.4-6.1,13-11.1,20.3-15.9c6.3-4.2,12.9-8.6,18.1-13.6l0.4,0.4c-5.2,5.1-11.8,9.5-18.2,
            13.7c-7.3,4.8-14.8,9.8-20.2,15.8c-11.5,13-14.3,25.2-17.8,40.8c-0.7,2.9-1.4,6-2.1,9.2c-4.5,18.3-9.8,36.6-15,
            54.3C686,305.1,679.7,326.6,674.8,348.2"
          />
          <path
            class="st1"
            d="M684.4,348.2l-0.5-0.1c5.3-21.8,11.8-43.6,18.1-64.7c5.2-17.4,10.6-35.3,15.2-53.2c0.8-2.9,1.4-5.6,2.1-8.3
            c3.9-15.9,7-28.5,19.2-41.9c5.5-6.1,13.1-11.1,20.5-16c6.5-4.3,13.2-8.7,18.5-13.9l0.4,0.4c-5.4,5.2-12.1,
            9.6-18.6,13.9c-7.3,4.8-14.9,9.8-20.4,15.9c-12,13.2-15.1,25.8-19,41.6c-0.7,2.7-1.3,5.4-2.1,8.3c-4.7,17.9-10,
            35.9-15.2,53.2C696.2,304.6,689.7,326.4,684.4,348.2"
          />
          <path
            class="st1"
            d="M314.1,150.7c-70.6,0-141.3,0-211.6-0.1v-0.6c157.9,0.1,318.4,0,473.7,0c67.1,0,134.3,0,201.4,0v0.5
            c-67.1,0-134.3,0-201.4,0C490,150.7,402.2,150.7,314.1,150.7 M309.9,157c-67.7,0-135.6-0.4-203-1.6l0-0.5
            c147.4,2.7,297.1,1.5,441.8,0.5c73.7-0.6,149.9-1.1,224.9-1.2v0.5c-75,0.1-151.2,0.6-224.9,1.2C470.2,156.4,
            390.2,157,309.9,157M305.8,162.4c-64.2,0-128.7-0.6-192.7-2.3l0-0.6c136.5,3.7,274.7,2.2,408.5,0.8c80.8-0.9,
            164.3-1.7,246.6-1.5v0.6c-82.3-0.3-165.8,0.6-246.6,1.5C450.6,161.6,378.3,162.4,305.8,162.4 M301.8,166.9
            c-60.6,0-121.4-0.6-181.8-2.5l0-0.5c125.5,3.8,252.8,2.4,375.8,1c87.1-1,177.2-2,265.9-1.1l0,
            0.6c-88.8-0.9-178.8,0.1-265.9,1.1C432.1,166.2,367.1,166.9,301.8,166.9M298.2,170.8c-57.1,
            0-114.4-0.6-171.3-2.3l0-0.5c115.3,3.4,232.3,2.2,345.4,1.1c92.7-1,188.6-1.9,283-0.4l0,0.5
            c-94.4-1.6-190.3-0.6-283,0.4C415,170.2,356.8,170.8,298.2,170.8 M295.8,174c-54.3,0-108.7-0.5-162.8-2l0-0.5
            c106.5,2.9,214.6,2,319.2,1.1c97.3-0.9,198-1.7,297,0.5l0,0.5c-99-2.2-199.7-1.4-297-0.5C400.8,173.5,348.4,174,
            295.8,174M744.1,177c-102.8-2.8-207.4-2-308.4-1.3c-97.7,0.7-198.6,1.5-298-1l0-0.6c99.4,2.5,200.3,1.7,298,1
            c101.1-0.8,205.6-1.6,308.5,1.3L744.1,177z"
          />
          <path
            class="st1"
            d="M739.8,179.7c-102.9-2.6-207.6-2-308.7-1.5c-94.7,0.5-192.6,1-288.9-1l0-0.5c96.3,2,194.2,1.5,288.9,1
            c101.2-0.5,205.8-1.1,308.8,1.5L739.8,179.7L739.8,179.7z M734.7,183.1c-102.5-1.9-206.6-1.6-307.3-1.3
            c-91.9,0.2-187,0.5-280.5-0.9l0-0.5c93.5,1.4,188.6,1.1,280.5,0.9c100.7-0.3,204.9-0.5,307.3,1.3L734.7,
            183.1L734.7,183.1zM730,187.4c-104.8-0.8-211.4-0.7-314.5-0.7c-86.7,0-176.4,0.1-264.6-0.4v-0.6c88.2,
            0.5,177.9,0.4,264.6,0.4c103.1,0,209.6-0.1,314.5,0.7C730,186.9,730,187.4,730,187.4z M313.6,194.7c-53.3,
            0-106.8,0-159.8-0.1V194c114.3,0.2,230.5,0.1,342.9,0c75.5-0.1,153.5-0.1,230.3-0.1v0.5c-76.8,0-154.8,0-230.3,
            0.1C436.5,194.6,375.1,194.7,313.6,194.7M276.2,203.9c-40.1,0-80.2-0.1-120.1-0.3V203c98.5,0.5,198.6,0.2,295.4,
            0c89.5-0.3,182-0.5,272.9-0.1v0.5c-91-0.4-183.5-0.1-272.9,0.1C393.9,203.7,335.1,203.9,276.2,203.9 M255.3,
            212.7c-32.3,0-64.6-0.1-96.8-0.4v-0.6c90.7,0.7,183,0.2,272.2-0.3c95.5-0.5,194.4-1.1,291.5-0.1l0,
            0.6c-97.2-1-196-0.4-291.5,0.1C373.1,212.4,314.2,212.7,255.3,212.7M242.6,221.2c-27.3,0-54.7-0.1-81.8-0.4
            v-0.5c86.1,0.9,173.6,0.1,258.2-0.7c98.7-0.9,200.8-1.8,301.2-0.1l0,0.5c-100.4-1.8-202.4-0.8-301.1,0.1C361.1,
            220.7,301.8,221.2,242.6,221.2 M220.9,229.2c-19.4,0-38.7-0.1-57.9-0.2v-0.5c79,0.7,159.2-0.2,236.9-1.1
            c104.3-1.2,212.2-2.5,318.2,0.2l0,0.5c-106-2.7-213.9-1.4-318.2-0.2C341.2,228.5,280.9,229.2,220.9,
            229.2 M208.8,237c-14.6,0-29.1-0.1-43.6-0.2v-0.6c74.8,0.6,150.9-0.5,224.5-1.5c107-1.5,217.7-3.1,326.4,0.4l0,
            0.5c-108.7-3.5-219.4-1.9-326.4-0.4C330.4,236.2,269.4,237,208.8,237 M206.8,244.9c-13.2,0-26.3,
            0-39.4-0.1v-0.6c73.3,0.6,147.9-0.6,220.1-1.8c107.1-1.7,217.8-3.5,326.6,0.5l0,
            0.5c-108.7-4-219.5-2.2-326.5-0.5C328.3,243.9,267.3,244.9,206.8,244.9 M214.5,252.8c-15,
            0-29.9-0.1-44.8-0.2V252c74.4,0.7,150-0.6,223.2-1.8c104.7-1.8,212.9-3.7,319.2,0.4l0,
            0.5c-106.3-4.1-214.5-2.2-319.2-0.4C334.3,251.7,274.2,252.8,214.5,252.8 M231.8,260.8
            c-20,0-39.9-0.1-59.8-0.4l0-0.5c78,1.1,157.3-0.3,234-1.6c99.6-1.7,202.6-3.5,303.8,0.1l0,
            0.5c-101.2-3.6-204.2-1.8-303.8-0.1C348.9,259.8,290.2,260.8,231.8,260.8 M259,269.2c-28.3,
            0-56.5-0.2-84.6-0.8l0-0.5c84.8,1.8,171,0.3,254.3-1.1c91.4-1.6,185.8-3.2,278.7-0.5l0,
            0.5c-92.9-2.7-187.4-1.1-278.7,0.5C373,268.3,316,269.2,259,269.2 M294.9,278.2c-39.4,
            0-78.8-0.5-118-1.7l0-0.5c95.7,3,192.9,1.4,287-0.2c78.9-1.3,160.6-2.7,240.9-1.3l0,0.5c-80.3-1.4-161.9,
            0-240.8,1.3C408.3,277.3,351.7,278.2,294.9,278.2 M335.9,288.1c-52.3,0-104.6-0.8-156.4-3.1l0-0.5c112.8,
            5,228,2.9,339.4,0.9c60-1.1,122-2.2,182.8-2.2v0.5c-60.8,0-122.8,1.1-182.8,2.2C458.7,286.9,397.3,288.1,335.9,
            288.1 M331.3,295.4c-49.9,0-99.9-0.7-149.4-2.8l0-0.5c109.5,4.6,221.3,2.6,329.4,0.7c61.6-1.1,125.2-2.2,
            187.7-2.1v0.5c-62.5-0.1-126.1,1-187.7,2.1C452.1,294.4,391.8,295.4,331.3,295.4 M327,309.3c-47,
            0-94.1-0.5-140.8-2l0-0.5c105.5,3.3,213,1.8,317,0.3c62.7-0.9,127.6-1.8,191.3-1.6v0.6c-63.7-0.2-128.6,
            0.7-191.3,1.6C445.2,308.5,386.2,309.3,327,309.3 M326.4,316
            c-46.2,0-92.4-0.4-138.3-1.5l0-0.5c104.3,2.6,210.4,1.4,313.1,0.2c62.8-0.7,127.7-1.4,191.5-1.3v0.5
            c-63.8-0.1-128.7,0.6-191.5,1.3C443.7,315.3,385.1,316,326.4,316 M440.6,321.5c19.9-0.1,39.7-0.3,59.4-0.5
            c62.6-0.5,127.3-1.1,190.9-0.9v0.5c-63.6-0.1-128.3,0.4-190.9,0.9c-57,0.5-115,1-173.2,1 M326.7,322.5c-45.7,
            0-91.5-0.3-136.9-1.1l0-0.5c83.3,1.5,167.8,1.3,250.8,0.6 M328.1,329c-45.6,0-91.3-0.2-136.6-0.7l0-0.5c102.7,
            1.3,207.2,0.7,308.3,0.1c62.1-0.3,126.3-0.7,189.4-0.6v0.6c-63.1-0.1-127.3,0.3-189.4,0.6C443.3,328.7,385.8,
            329,328.1,329 M331.5,335.4c-46.2,0-92.4-0.1-138.3-0.4v-0.5c102.6,0.7,207,0.4,308,0.1c61.1-0.2,124.3-0.4,
            186.4-0.3v0.6c-62.1,0-125.3,0.1-186.4,0.3C445.4,335.2,388.5,335.4,331.5,335.4 M339.5,341.9c-48.3,0-96.6,
            0-144.7-0.2v-0.5c103.8,0.3,209.3,0.2,311.3,0.1c58.9-0.1,119.8-0.1,179.7-0.1v0.5c-59.9,0-120.8,0.1-179.7,
            0.1C451.4,341.8,395.5,341.9,339.5,341.9 M359.1,348.4c-54.2,0-108.3,0-162.5,0v-0.5c108.3,0,216.7,0,325,
            0l162.5,0v0.5l-162.5,0C467.5,348.4,413.3,348.4,359.1,348.4"
          />
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__bm"
                class="st104"
                d="M153.6,189.1c-1,0-2-0.3-2.9-0.9l-51.3-33.9c-2.4-1.6-3.1-4.9-1.5-7.4
        c1.6-2.4,4.9-3.1,7.4-1.5l51.3,33.9c2.4,1.6,3.1,4.9,1.5,7.4C157,188.3,155.3,189.1,153.6,189.1"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__bm_2_"
                gradientUnits="userSpaceOnUse"
                x1="-193.21"
                y1="751.401"
                x2="-193.297"
                y2="751.3002"
                gradientTransform="matrix(61.8714 0 0 -44.4957 12084.1494 33599.332)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.4693" style="stop-color:#D4D4D4" />
                <stop offset="0.5405" style="stop-color:#D5D5D5" />
                <stop offset="0.7894" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__bm_1_"
                class="st105"
                d="M153.6,189.1c-1,0-2-0.3-2.9-0.9l-51.3-33.9c-2.4-1.6-3.1-4.9-1.5-7.4
        c1.6-2.4,4.9-3.1,7.4-1.5l51.3,33.9c2.4,1.6,3.1,4.9,1.5,7.4C157,188.3,155.3,189.1,153.6,189.1"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__bo"
                class="st104"
                d="M728.2,189.1c-1.7,0-3.4-0.8-4.4-2.4c-1.6-2.4-0.9-5.7,1.5-7.4l51.3-33.9
        c2.4-1.6,5.7-0.9,7.4,1.5c1.6,2.4,0.9,5.7-1.5,7.4l-51.3,33.9C730.2,188.8,729.2,189.1,728.2,189.1"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__bo_2_"
                gradientUnits="userSpaceOnUse"
                x1="-193.3336"
                y1="751.4563"
                x2="-193.2035"
                y2="751.3245"
                gradientTransform="matrix(61.8724 0 0 -44.4966 12710.1602 33600)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.4693" style="stop-color:#D4D4D4" />
                <stop offset="0.5385" style="stop-color:#C7C7C7" />
                <stop offset="0.7894" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__bo_1_"
                class="st106"
                d="M728.2,189.1c-1.7,0-3.4-0.8-4.4-2.4c-1.6-2.4-0.9-5.7,1.5-7.4l51.3-33.9
        c2.4-1.6,5.7-0.9,7.4,1.5c1.6,2.4,0.9,5.7-1.5,7.4l-51.3,33.9C730.2,188.8,729.2,189.1,728.2,189.1"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__bq"
                class="st104"
                d="M731.8,183.4c0.4-1.3,0.1-2.8-0.7-3.9c-0.8-1.1-2.1-1.8-3.5-1.8H153
        c-1.4,0-2.7,0.7-3.5,1.8c-0.8,1.1-1.1,2.5-0.7,3.9l0.9,3.2h581.3L731.8,183.4z"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__bq_2_"
                gradientUnits="userSpaceOnUse"
                x1="-197.5046"
                y1="715.0063"
                x2="-197.5046"
                y2="714.0063"
                gradientTransform="matrix(583.4112 0 0 -8.847 115666.6406 6503.4224)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.456" style="stop-color:#D4D4D4" />
                <stop offset="0.5975" style="stop-color:#C8C8C8" />
                <stop offset="0.9122" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__bq_1_"
                class="st107"
                d="M731.8,183.4c0.4-1.3,0.1-2.8-0.7-3.9c-0.8-1.1-2.1-1.8-3.5-1.8H153
        c-1.4,0-2.7,0.7-3.5,1.8c-0.8,1.1-1.1,2.5-0.7,3.9l0.9,3.2h581.3L731.8,183.4z"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__bs"
                class="st104"
                d="M195.8,349.9c0.7,2.3,3.1,3.7,5.5,3c2.4-0.7,3.7-3.1,3.1-5.5l-45.5-160.3h-9.2
        L195.8,349.9L195.8,349.9z"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__bs_2_"
                gradientUnits="userSpaceOnUse"
                x1="-192.6151"
                y1="758.0818"
                x2="-192.6337"
                y2="758.0654"
                gradientTransform="matrix(54.8333 0 0 -165.9138 10739.6133 126042.4063)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.3323" style="stop-color:#E1E1E1" />
                <stop offset="0.5471" style="stop-color:#D4D4D4" />
                <stop offset="0.7894" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__bs_1_"
                class="st108"
                d="M195.8,349.9c0.7,2.3,3.1,3.7,5.5,3c2.4-0.7,3.7-3.1,3.1-5.5l-45.5-160.3h-9.2
        L195.8,349.9L195.8,349.9z"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__bu"
                class="st104"
                d="M721.7,187.2l-45.5,160.3c-0.7,2.4,0.7,4.8,3,5.5c0.4,0.1,0.8,0.2,1.2,0.2
        c1.9,0,3.7-1.3,4.3-3.2l46.2-162.7L721.7,187.2L721.7,187.2z"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__bu_2_"
                gradientUnits="userSpaceOnUse"
                x1="-192.5974"
                y1="758.0408"
                x2="-192.5786"
                y2="758.025"
                gradientTransform="matrix(54.8323 0 0 -165.915 11265.832 126043.3203)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.4233" style="stop-color:#CACACA" />
                <stop offset="0.548" style="stop-color:#D4D4D4" />
                <stop offset="0.7894" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__bu_1_"
                class="st109"
                d="M721.7,187.2l-45.5,160.3c-0.7,2.4,0.7,4.8,3,5.5c0.4,0.1,0.8,0.2,1.2,0.2
        c1.9,0,3.7-1.3,4.3-3.2l46.2-162.7L721.7,187.2L721.7,187.2z"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__bw"
                class="st104"
                d="M679.6,352.4H200.7c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4h478.9c2.4,0,4.4,2,4.4,4.4
        C684,350.4,682,352.4,679.6,352.4"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__bw_2_"
                gradientUnits="userSpaceOnUse"
                x1="-197.4054"
                y1="715.0012"
                x2="-197.4054"
                y2="714.0012"
                gradientTransform="matrix(487.775 0 0 -8.846 96729.5547 6668.4287)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.4693" style="stop-color:#D4D4D4" />
                <stop offset="0.5601" style="stop-color:#C6C4C4" />
                <stop offset="0.7894" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__bw_1_"
                class="st110"
                d="M679.6,352.4H200.7c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4h478.9
        c2.4,0,4.4,2,4.4,4.4C684,350.4,682,352.4,679.6,352.4"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__by"
                class="st104"
                d="M101.5,382c-1.9,0-3.6-1.2-4.2-3.2c-0.7-2.3,0.6-4.8,2.9-5.5l99.2-29.7
        c2.3-0.7,4.7,0.7,5.4,3c0.7,2.3-0.6,4.8-2.9,5.5l-99.2,29.7C102.3,382,101.9,382,101.5,382"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__by_2_"
                gradientUnits="userSpaceOnUse"
                x1="-195.3122"
                y1="749.9836"
                x2="-195.2908"
                y2="749.9586"
                gradientTransform="matrix(107.9238 0 0 -38.5112 21226.1543 29243.9727)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.4693" style="stop-color:#D4D4D4" />
                <stop offset="0.8602" style="stop-color:#C7C7C7" />
                <stop offset="0.9095" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__by_1_"
                class="st111"
                d="M101.5,382c-1.9,0-3.6-1.2-4.2-3.2c-0.7-2.3,0.6-4.8,2.9-5.5l99.2-29.7
        c2.3-0.7,4.7,0.7,5.4,3c0.7,2.3-0.6,4.8-2.9,5.5l-99.2,29.7C102.3,382,101.9,382,101.5,382"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__bA"
                class="st104"
                d="M780.4,382c-0.4,0-0.8-0.1-1.3-0.2l-100.8-29.7c-2.3-0.7-3.7-3.1-3-5.5
        c0.7-2.3,3.2-3.7,5.5-3l100.8,29.7c2.3,0.7,3.7,3.1,3,5.5C784,380.8,782.3,382,780.4,382"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__bA_2_"
                gradientUnits="userSpaceOnUse"
                x1="-195.3541"
                y1="749.8986"
                x2="-195.373"
                y2="749.8754"
                gradientTransform="matrix(109.6046 0 0 -38.5105 22137.7969 29243.4277)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.4693" style="stop-color:#D4D4D4" />
                <stop offset="0.6472" style="stop-color:#C1BEBE" />
                <stop offset="0.9305" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__bA_1_"
                class="st112"
                d="M780.4,382c-0.4,0-0.8-0.1-1.3-0.2l-100.8-29.7c-2.3-0.7-3.7-3.1-3-5.5
        c0.7-2.3,3.2-3.7,5.5-3l100.8,29.7c2.3,0.7,3.7,3.1,3,5.5C784,380.8,782.3,382,780.4,382"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__bC"
                class="st104"
                d="M101.1,381.9h2.4c2.3,0,4.1-1.8,4.1-4.1V155.2h0.1L97,144.9v232.9
        C97,380.1,98.9,381.9,101.1,381.9"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__bC_2_"
                gradientUnits="userSpaceOnUse"
                x1="-170.4331"
                y1="758.7918"
                x2="-170.4313"
                y2="758.7918"
                gradientTransform="matrix(10.697 0 0 -237.04 1925.5055 180127.7969)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.4693" style="stop-color:#D4D4D4" />
                <stop offset="0.5317" style="stop-color:#CECDCD" />
                <stop offset="0.7894" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__bC_1_"
                class="st113"
                d="M101.1,381.9h2.4c2.3,0,4.1-1.8,4.1-4.1V155.2h0.1L97,144.9v232.9
        C97,380.1,98.9,381.9,101.1,381.9"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path
                id="prefix__bE"
                class="st104"
                d="M774.1,155.6v222.2c0,2.3,1.8,4.1,4.1,4.1h2.4c2.3,0,4.1-1.8,4.1-4.1V144.8L774.1,155.6
        L774.1,155.6z"
              />
            </g>
            <g>
              <linearGradient
                id="prefix__bE_2_"
                gradientUnits="userSpaceOnUse"
                x1="-170.2227"
                y1="758.7947"
                x2="-170.2209"
                y2="758.7947"
                gradientTransform="matrix(10.616 0 0 -237.049 2586.5076 180134.6406)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EAEAEA" />
                <stop offset="0.4756" style="stop-color:#D4D4D4" />
                <stop offset="0.5433" style="stop-color:#CBCBCB" />
                <stop offset="0.7894" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path
                id="prefix__bE_1_"
                class="st114"
                d="M774.1,155.6v222.2c0,2.3,1.8,4.1,4.1,4.1h2.4c2.3,0,4.1-1.8,4.1-4.1V144.8
                L774.1,155.6L774.1,155.6z"
              />
            </g>
          </g>
          <g transform="translate(0 .136)">
            <g>
              <path id="prefix__bG" class="st104" d="M784.7,144.6H97v0.2l10.7,10.4h666.4v0.4l10.6-10.7V144.6z" />
            </g>
            <g>
              <linearGradient
                id="prefix__bG_2_"
                gradientUnits="userSpaceOnUse"
                x1="-197.5812"
                y1="723.9365"
                x2="-197.5812"
                y2="722.9365"
                gradientTransform="matrix(687.692 0 0 -10.978 136315.9219 8091.9858)"
              >
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="0.2148" style="stop-color:#EEEBEB" />
                <stop offset="0.4693" style="stop-color:#C6C6C6" />
                <stop offset="0.7894" style="stop-color:#ECECEC" />
                <stop offset="1" style="stop-color:#FFFFFF" />
              </linearGradient>
              <path id="prefix__bG_1_" class="st115" d="M784.7,144.6H97v0.2l10.7,10.4h666.4v0.4l10.6-10.7V144.6z" />
            </g>
          </g>
        </g>
      </g>
      <line class="st116" x1="-9" y1="507.7" x2="891" y2="507.7" />
      <path class="st117" d="M159.9,541.6" />
      <path class="st103" d="M702.6,506.6c-54.1,44.6-153.9,74.5-267.9,74.5c-113.4,0-212.7-29.6-267-73.8" />
      <path class="st117" d="M539.5,327.8" />
      <path class="st117" d="M434.6,319" />
      <line class="st103" x1="43.2" y1="384" x2="-2.5" y2="407.1" />
      <line class="st103" x1="891.7" y1="440.2" x2="825.1" y2="383.2" />
      <line class="st118" x1="193.2" y1="301.7" x2="689.9" y2="300.4" />
      <template v-for="(play, index) in showPlays">
        <Ball
          class="hover-ball"
          :play="play"
          :key="index"
          @showTooltip="showTooltip"
          @hideTooltip="hideTooltip"
          @onClickOver="onClickOver"
        ></Ball>
      </template>
    </svg>
    <div class="cont-data-label">
      <div class="cont-data-label-text">Haz click en un balón para ver el video</div>
    </div>

    <Tooltip :data="dataTooltip">
      <div class="tooltip-data has-text-left" ref="toltipcol" :class="[dataTooltip.visible ? 'visible' : '']">
        <div v-if="!isPlayerView">
          <span class="bold">{{ $t('goal_tooltip.player') }}: </span>{{ dataPlay.playerName }}
        </div>
        <div>
          <span class="bold">{{ $t('goal_tooltip.minute') }}: </span>{{ dataPlay.minute }}
        </div>
        <div>
          <span class="bold">{{ $t('goal_tooltip.opponent') }}: </span>{{ dataPlay.rivalName }}
          <img :src="dataPlay.rivalLogo" width="25" style="vertical-align:middle" />
        </div>
        <div class="line-buttom" v-if="isMobile">
          <div class="button-viewvideos" @click="setOpenMediaMovil(dataTooltip)">
            <div class="button-viewvideos__text">Ver video</div>
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_playfield.png" />
          </div>
        </div>
      </div>
    </Tooltip>
  </div>
</template>

<script>
import Ball from '@/components/Elements/Ball';
import IconBall from '@/components/Elements/IconBall';
import Tooltip from '@/components/Elements/Tooltip';
import filtersGoal from '@/data/filtersGoal.js';
import teamGoalPlayIndexes from '@/data/team/teamGoalPlayIndexes';
import { mapGetters, mapMutations, mapState } from 'vuex';
const INDEXES = teamGoalPlayIndexes();

export default {
  name: 'SoccerGoal',
  components: { Ball, IconBall, Tooltip },
  props: {
    players: {
      type: Array,
      required: true,
    },
    teams: {
      type: Array,
      required: true,
    },
    plays: {
      type: Array,
      required: true,
    },
    // Possible values: 'team' or 'player'
    sectionType: {
      type: String,
      required: false,
    },
    // Possible values: 'offensive' or 'defensive'
    type: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      clickaux: false,
      categories: null,
      categoriesSelected: [],
      dataTooltip: { x: 0, y: 0, visible: false },
      dataPlay: { playerName: '', minute: 0, rivalName: '', rivalLogo: '' },
    };
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
    this.categories = filtersGoal[this.categoryType];
    this.categoriesSelected = this.categories.map(category => category.category_id);
  },
  computed: {
    ...mapGetters('teamsGeneral', {
      teamId: 'teamId',
    }),
    ...mapGetters('gamesGeneral', ['seasonGamesPlayed']),
    ...mapGetters('filterGeneral', {
      getGamesPlayedByTeam: 'getGamesPlayedByTeam',
      getResults: 'getResults',
      getSections: 'getSections',
      getPlayingAs: 'getPlayingAs',
      getSelectedGamesIds: 'getSelectedGamesIds',
      seasonSelected: 'getSeasonId',
    }),
    ...mapGetters('playersGeneral', ['player']),
    ...mapState('filterGeneral', ['tournamentsForMediaPlayer']),
    /**
     * @author Cristhian Gómez
     * @description Campo computado que devuelve boleano si se encuentra en la ruta player
     */
    isPlayerView() {
      return this.$route.name === 'player';
    },
    /**
     * Prepare the plays to show.
     * @return {{st, play_id: *, category_id: *, playerName: *, x: *, category_type: *, y: *, category_color: (string), time: *}[]}
     */
    isMobile() {
      return this.$mq === 'mobile';
    },
    showPlays() {
      return this.playsFiltered.map(play => {
        const game = this.seasonGamesPlayed.find(game => game.game_id === play[INDEXES.gameId]);
        let team = {};

        if (game) {
          const rivalTeamId = play[INDEXES.playingAs] === 1 ? game.visiting_team : game.home_team;
          team = this.teams.find(team => team.team_id === rivalTeamId);
          team = team ? team : {};
        }

        const matchedPlayer = this.players.find(player => player.player_id === play[INDEXES.playerId]);
        const category = this.categories.find(category => category.category_id === play[INDEXES.categoryId]);
        return {
          play_id: play[INDEXES.playId],
          playerName: matchedPlayer ? matchedPlayer.name : '',
          time: play[INDEXES.momentOfPlay],
          category_id: play[INDEXES.categoryId],
          category_color: this.categories.find(category => category.category_id === play[INDEXES.categoryId])
            .category_color,
          st: this.categories.find(category => category.category_id === play[INDEXES.categoryId]).st,
          category_type: play[INDEXES.categoryType],
          x: play[INDEXES.coordinateX],
          y: play[INDEXES.coordinateY],
          rivalName: team.team_name || '',
          rivalLogo: team.logo || '',
          generalName: category.generalName,
          singleName: category.singleName,
        };
      });
    },
    /**
     * Plays Filtered
     * @return Array
     */
    playsFiltered() {
      return this.plays.filter(play => {
        const game = this.seasonGamesPlayed.find(game => game.game_id === play[INDEXES.gameId]);
        let rivalTeamId = 0;

        if (game) {
          rivalTeamId =
            play[4] === 12000 ? (play[INDEXES.playingAs] === 1 ? game.visiting_team : game.home_team) : null;
        }

        return (
          this.categoriesSelected.includes(play[4]) && (play[4] !== 12000 ? true : this.player.team_id !== rivalTeamId)
        );
      });
    },
    ...mapGetters('filterGeneral', {
      categoryType: 'getCategoryType',
    }),
  },
  methods: {
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    /**
     * Show Tooltip of play
     * @param dataTooltip
     * @return void
     */
    onClickOutside(event) {
      const { toltipcol } = this.$refs;
      if (!toltipcol || toltipcol.contains(event.target)) return;
      if (this.isMobile) {
        if (!this.clickaux) {
          this.hideTooltipMovil();
        }
      }
      this.clickaux = false;
    },
    setOpenMediaMovil(dataTooltip) {
      var categoriesSelected = [];
      this.dataTooltip.visible = false;
      if (this.sectionType === 'team') {
        if (this.type === 'offensive') {
          switch (dataTooltip.playInfo.category_id) {
            case 12000:
              categoriesSelected = [12, 55, '35_r', '54_r'];
              break;
            case 53800:
              categoriesSelected = [538, 541, 545, 548, 159, 168, 177, 331, 334];
              break;
            case 59800:
              categoriesSelected = [598, 600, 602, 604, 582, 580, 572, 574, 578];
              break;
            case 60000:
              categoriesSelected = [598, 600, 602, 604, 582, 580, 572, 574, 578];
              break;
          }
        } else {
          switch (dataTooltip.playInfo.category_id) {
            case 12000:
              categoriesSelected = [257, 40];
              break;
            case 53800:
              categoriesSelected = ['538_r', '541_r', '545_r', '548_r', '159_r', '168_r', '177_r', '331_r', '334_r'];
              break;
            case 59800:
              categoriesSelected = ['598_r', '600_r', '602_r', '604_r', '582_r', '580_r', '572_r', '574_r', '578_r'];
              break;
            case 60000:
              categoriesSelected = [39];
              break;
          }
        }
      } else {
        switch (dataTooltip.playInfo.category_id) {
          case 12000:
            categoriesSelected = this.player.position_id == 1 ? [40] : [12, 55];
            break;
          case 53800:
            categoriesSelected = [538, 541, 545, 548, 159, 168, 177, 331, 334];
            break;
          case 59800:
            categoriesSelected = [598, 600, 602, 604, 582, 580, 572, 574, 578];
            break;
          case 60000:
            categoriesSelected = this.player.position_id == 1 ? [39] : [598, 600, 602, 604, 582, 580, 572, 574, 578];
            break;
        }
      }
      const jsonConfig = {
        seasonId: this.seasonSelected,
        tournaments: this.tournamentsForMediaPlayer,
        categoryIds: categoriesSelected,
        categorySingleName:
          this.type === 'offensive' && this.sectionType === 'player' && dataTooltip.playInfo.category_id === 60000
            ? 'Remate a destino'
            : dataTooltip.playInfo.generalName,
        mainSectionType: 1,
        playListType: this.sectionType === 'team' ? 3 : 2,
        gameIds: this.getSelectedGamesIds,
        matchResult: this.getResults,
        playData: { playId: dataTooltip.playInfo.play_id },
        isPost: dataTooltip.playInfo.category_id === 59800 ? 1 : 0,
        advancedFilter: {
          playListTitle:
            this.type === 'offensive' && this.sectionType === 'player' && dataTooltip.playInfo.category_id === 60000
              ? 'Remates a destino'
              : dataTooltip.playInfo.generalName,
          mainCategoryId: {},
          playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
          timeSections: this.getSections,
          fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        },
      };
      if (this.teamId) {
        jsonConfig.playerIds = [];
        jsonConfig.teamId = this.teamId;
      } else {
        jsonConfig.playerIds = [this.player.player_id];
        jsonConfig.teamId = 0;
      }
      this.setModalInitialState(jsonConfig);
      this.setIsModalOpen(true);
    },
    onClickOver(dataTooltip) {
      this.clickaux = true;
      if (this.isMobile) {
        const goalBounds = this.$refs.goal.getBoundingClientRect();
        dataTooltip.x = dataTooltip.x - goalBounds.x;
        dataTooltip.y = goalBounds.y < 0 ? dataTooltip.y + -1 * goalBounds.y : dataTooltip.y - goalBounds.y;
        dataTooltip.y += 65;
        Object.assign(this.dataPlay, dataTooltip);
        Object.assign(this.dataTooltip, dataTooltip);
        this.dataTooltip.visible = true;
      } else {
        let categoriesSelected = [];
        if (this.sectionType === 'team') {
          if (this.type === 'offensive') {
            switch (dataTooltip.playInfo.category_id) {
              case 12000:
                categoriesSelected = [12, 55, '35_r', '54_r'];
                break;
              case 53800:
                categoriesSelected = [538, 541, 545, 548, 159, 168, 177, 331, 334];
                break;
              case 59800:
                categoriesSelected = [598, 600, 602, 604, 582, 580, 572, 574, 578];
                break;
              case 60000:
                categoriesSelected = [598, 600, 602, 604, 582, 580, 572, 574, 578];
                break;
            }
          } else {
            switch (dataTooltip.playInfo.category_id) {
              case 12000:
                categoriesSelected = [257, 40];
                break;
              case 53800:
                categoriesSelected = ['538_r', '541_r', '545_r', '548_r', '159_r', '168_r', '177_r', '331_r', '334_r'];
                break;
              case 59800:
                categoriesSelected = ['598_r', '600_r', '602_r', '604_r', '582_r', '580_r', '572_r', '574_r', '578_r'];
                break;
              case 60000:
                categoriesSelected = [39];
                break;
            }
          }
        } else {
          switch (dataTooltip.playInfo.category_id) {
            case 12000:
              categoriesSelected = this.player.position_id == 1 ? [40] : [12, 55];
              break;
            case 53800:
              categoriesSelected = [538, 541, 545, 548, 159, 168, 177, 331, 334];
              break;
            case 59800:
              categoriesSelected = [598, 600, 602, 604, 582, 580, 572, 574, 578];
              break;
            case 60000:
              categoriesSelected = this.player.position_id == 1 ? [39] : [598, 600, 602, 604, 582, 580, 572, 574, 578];
              break;
          }
        }
        let jsonConfig = {
          seasonId: this.seasonSelected,
          tournaments: this.tournamentsForMediaPlayer,
          categoryIds: categoriesSelected,
          categorySingleName:
            this.type === 'offensive' && this.sectionType === 'player' && dataTooltip.playInfo.category_id === 60000
              ? 'Remate a destino'
              : dataTooltip.playInfo.generalName,
          mainSectionType: 1,
          playListType: this.sectionType === 'team' ? 3 : 2,
          gameIds: this.getSelectedGamesIds,
          matchResult: this.getResults,
          playData: { playId: dataTooltip.playInfo.play_id },
          isPost: dataTooltip.playInfo.category_id === 59800 ? 1 : 0,
          advancedFilter: {
            playListTitle:
              this.type === 'offensive' && this.sectionType === 'player' && dataTooltip.playInfo.category_id === 60000
                ? 'Remates a destino'
                : dataTooltip.playInfo.generalName,
            mainCategoryId: {},
            playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
            timeSections: this.getSections,
            fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
          },
        };
        if (this.teamId) {
          jsonConfig.playerIds = [];
          jsonConfig.teamId = this.teamId;
        } else {
          jsonConfig.playerIds = [this.player.player_id];
          jsonConfig.teamId = 0;
        }
        this.setModalInitialState(jsonConfig);
        this.setIsModalOpen(true);
      }
    },
    showTooltip(dataTooltip) {
      if (!this.isMobile) {
        const goalBounds = this.$refs.goal.getBoundingClientRect();
        dataTooltip.x = dataTooltip.x - goalBounds.x;
        dataTooltip.y = goalBounds.y < 0 ? dataTooltip.y + -1 * goalBounds.y : dataTooltip.y - goalBounds.y;
        dataTooltip.y += 65;
        Object.assign(this.dataPlay, dataTooltip);
        Object.assign(this.dataTooltip, dataTooltip);
        this.dataTooltip.visible = true;
      }
    },
    /**
     * Hide Tooltip
     * @return void
     */
    hideTooltipMovil() {
      this.dataTooltip.visible = false;
    },
    hideTooltip() {
      if (!this.isMobile) {
        this.dataPlay = { playerName: '', minute: 0, rivalName: '', rivalLogo: '' };
        this.dataTooltip.visible = false;
      }
    },
    /**
     * @author Rigoberto Sanchez
     * @descripcion Emit event when change category
     */
    onClickCategory(value) {
      this.$emit('changeCategory', {
        name: value.target.name,
        checked: value.target.checked,
      });
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
  },
};
</script>

<style lang="scss" scoped>
.line-buttom {
  width: 100%;
  height: 45px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.button-viewvideos {
  width: 123px;
  height: 30px;
  border-radius: 25px;
  background-color: #a5cd39;

  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  &__text {
    font-family: 'Avenir-Bold';
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
  }
  img {
    filter: grayscale(100%);
    height: 20px;
    margin-left: 3px;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
</style>
<style type="text/css" scoped>
.hover-ball:hover {
  opacity: 0.8;
  cursor: pointer;
}
.cont-data-label-text {
  width: 62%;
  height: 32px;
  border-radius: 11px;
  background-color: rgba(35, 35, 35, 0.7);
  /* margin: 0 auto; */
  transform: translateX(31%);
  font-size: 18px;
  color: white;
  font-family: 'Heebo';
}

.cont-data-label {
  width: 100%;
  height: 32px;
  position: absolute;
  bottom: 140px;
  line-height: 32px;
  text-align: center;
}
@media (max-width: 1250px) {
  .cont-data-label {
    bottom: 250px;
    height: 38px;
    line-height: 38px;
  }
  .cont-data-label-text {
    width: 62%;
    height: 38px;
    font-size: 20px;
  }
}
@media (max-width: 1100px) {
  .cont-data-label {
    bottom: 230px;
  }
}
@media (max-width: 960px) {
  .cont-data-label {
    bottom: 200px;
  }
}
@media (max-width: 768px) {
  .cont-data-label {
    bottom: 170px;
    height: 32px;
    line-height: 32px;
  }
  .cont-data-label-text {
    height: 32px;
    font-size: 18px;
  }
}
@media (max-width: 700px) {
  .cont-data-label {
    bottom: 150px;
  }
}
@media (max-width: 630px) {
  .cont-data-label {
    bottom: 140px;
  }
}
@media (max-width: 580px) {
  .cont-data-label {
    bottom: 120px;
  }
  .cont-data-label-text {
    font-size: 16px;
  }
}
@media (max-width: 510px) {
  .cont-data-label {
    bottom: 100px;
  }
  .cont-data-label-text {
    font-size: 15px;
    width: 60%;
  }
}
@media (max-width: 460px) {
  .cont-data-label {
    bottom: 92px;
  }
  .cont-data-label-text {
    font-size: 13px;
    width: 60%;
  }
}
@media (max-width: 400px) {
  .cont-data-label {
    bottom: 92px;
  }
  .cont-data-label-text {
    font-size: 12px;
    width: 60%;
  }
}
@media (max-width: 345px) {
  .cont-data-label {
    bottom: 75px;
  }
}
.goal {
  position: relative;
  border-radius: 21px;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.5);
  background-image: linear-gradient(to top, #417505, #ffffff 53%);
}
.st0 {
  opacity: 0.5;
  fill: #505050;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
  enable-background: new;
}
.st1 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st2 {
  filter: url(#Adobe_OpacityMaskFilter);
}
.st3 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #ffffff;
}
.st4 {
  mask: url(#prefix__b_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st5 {
  filter: url(#Adobe_OpacityMaskFilter_1_);
}
.st6 {
  mask: url(#prefix__d_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st7 {
  filter: url(#Adobe_OpacityMaskFilter_2_);
}
.st8 {
  mask: url(#prefix__f_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st9 {
  filter: url(#Adobe_OpacityMaskFilter_3_);
}
.st10 {
  mask: url(#prefix__h_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st11 {
  filter: url(#Adobe_OpacityMaskFilter_4_);
}
.st12 {
  mask: url(#prefix__j_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st13 {
  filter: url(#Adobe_OpacityMaskFilter_5_);
}
.st14 {
  mask: url(#prefix__l_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st15 {
  filter: url(#Adobe_OpacityMaskFilter_6_);
}
.st16 {
  mask: url(#prefix__n_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st17 {
  filter: url(#Adobe_OpacityMaskFilter_7_);
}
.st18 {
  mask: url(#prefix__p_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st19 {
  filter: url(#Adobe_OpacityMaskFilter_8_);
}
.st20 {
  mask: url(#prefix__r_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st21 {
  filter: url(#Adobe_OpacityMaskFilter_9_);
}
.st22 {
  mask: url(#prefix__t_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st23 {
  filter: url(#Adobe_OpacityMaskFilter_10_);
}
.st24 {
  mask: url(#prefix__v_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st25 {
  filter: url(#Adobe_OpacityMaskFilter_11_);
}
.st26 {
  mask: url(#prefix__x_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st27 {
  filter: url(#Adobe_OpacityMaskFilter_12_);
}
.st28 {
  mask: url(#prefix__z_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st29 {
  filter: url(#Adobe_OpacityMaskFilter_13_);
}
.st30 {
  mask: url(#prefix__B_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st31 {
  filter: url(#Adobe_OpacityMaskFilter_14_);
}
.st32 {
  mask: url(#prefix__D_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st33 {
  filter: url(#Adobe_OpacityMaskFilter_15_);
}
.st34 {
  mask: url(#prefix__F_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st35 {
  filter: url(#Adobe_OpacityMaskFilter_16_);
}
.st36 {
  mask: url(#prefix__H_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st37 {
  filter: url(#Adobe_OpacityMaskFilter_17_);
}
.st38 {
  mask: url(#prefix__J_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st39 {
  filter: url(#Adobe_OpacityMaskFilter_18_);
}
.st40 {
  mask: url(#prefix__L_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st41 {
  filter: url(#Adobe_OpacityMaskFilter_19_);
}
.st42 {
  mask: url(#prefix__N_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st43 {
  filter: url(#Adobe_OpacityMaskFilter_20_);
}
.st44 {
  mask: url(#prefix__P_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st45 {
  filter: url(#Adobe_OpacityMaskFilter_21_);
}
.st46 {
  mask: url(#prefix__R_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st47 {
  filter: url(#Adobe_OpacityMaskFilter_22_);
}
.st48 {
  mask: url(#prefix__T_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st49 {
  filter: url(#Adobe_OpacityMaskFilter_23_);
}
.st50 {
  mask: url(#prefix__V_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st51 {
  filter: url(#Adobe_OpacityMaskFilter_24_);
}
.st52 {
  mask: url(#prefix__X_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st53 {
  filter: url(#Adobe_OpacityMaskFilter_25_);
}
.st54 {
  mask: url(#prefix__ah_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st55 {
  filter: url(#Adobe_OpacityMaskFilter_26_);
}
.st56 {
  mask: url(#prefix__aj_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st57 {
  filter: url(#Adobe_OpacityMaskFilter_27_);
}
.st58 {
  mask: url(#prefix__al_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st59 {
  filter: url(#Adobe_OpacityMaskFilter_28_);
}
.st60 {
  mask: url(#prefix__an_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st61 {
  filter: url(#Adobe_OpacityMaskFilter_29_);
}
.st62 {
  mask: url(#prefix__ap_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st63 {
  filter: url(#Adobe_OpacityMaskFilter_30_);
}
.st64 {
  mask: url(#prefix__ar_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st65 {
  filter: url(#Adobe_OpacityMaskFilter_31_);
}
.st66 {
  mask: url(#prefix__at_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st67 {
  filter: url(#Adobe_OpacityMaskFilter_32_);
}
.st68 {
  mask: url(#prefix__av_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st69 {
  filter: url(#Adobe_OpacityMaskFilter_33_);
}
.st70 {
  mask: url(#prefix__ax_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st71 {
  filter: url(#Adobe_OpacityMaskFilter_34_);
}
.st72 {
  mask: url(#prefix__az_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st73 {
  filter: url(#Adobe_OpacityMaskFilter_35_);
}
.st74 {
  mask: url(#prefix__aB_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st75 {
  filter: url(#Adobe_OpacityMaskFilter_36_);
}
.st76 {
  mask: url(#prefix__aD_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st77 {
  filter: url(#Adobe_OpacityMaskFilter_37_);
}
.st78 {
  mask: url(#prefix__aF_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st79 {
  filter: url(#Adobe_OpacityMaskFilter_38_);
}
.st80 {
  mask: url(#prefix__aH_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st81 {
  filter: url(#Adobe_OpacityMaskFilter_39_);
}
.st82 {
  mask: url(#prefix__aJ_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st83 {
  filter: url(#Adobe_OpacityMaskFilter_40_);
}
.st84 {
  mask: url(#prefix__aL_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st85 {
  filter: url(#Adobe_OpacityMaskFilter_41_);
}
.st86 {
  mask: url(#prefix__aN_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st87 {
  filter: url(#Adobe_OpacityMaskFilter_42_);
}
.st88 {
  mask: url(#prefix__aP_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st89 {
  filter: url(#Adobe_OpacityMaskFilter_43_);
}
.st90 {
  mask: url(#prefix__aR_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st91 {
  filter: url(#Adobe_OpacityMaskFilter_44_);
}
.st92 {
  mask: url(#prefix__aT_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st93 {
  filter: url(#Adobe_OpacityMaskFilter_45_);
}
.st94 {
  mask: url(#prefix__aV_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st95 {
  filter: url(#Adobe_OpacityMaskFilter_46_);
}
.st96 {
  mask: url(#prefix__aX_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st97 {
  filter: url(#Adobe_OpacityMaskFilter_47_);
}
.st98 {
  mask: url(#prefix__aZ_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st99 {
  filter: url(#Adobe_OpacityMaskFilter_48_);
}
.st100 {
  mask: url(#prefix__bb_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st101 {
  filter: url(#Adobe_OpacityMaskFilter_49_);
}
.st102 {
  mask: url(#prefix__bd_1_);
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st103 {
  fill: none;
  stroke: #ffffff;
  stroke-width: 6;
  stroke-miterlimit: 10;
}
.st104 {
  fill: #ffffff;
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st105 {
  fill: url(#prefix__bm_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st106 {
  fill: url(#prefix__bo_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st107 {
  fill: url(#prefix__bq_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st108 {
  fill: url(#prefix__bs_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st109 {
  fill: url(#prefix__bu_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st110 {
  fill: url(#prefix__bw_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st111 {
  fill: url(#prefix__by_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st112 {
  fill: url(#prefix__bA_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st113 {
  fill: url(#prefix__bC_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st114 {
  fill: url(#prefix__bE_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st115 {
  fill: url(#prefix__bG_2_);
  stroke: #c9c9c9;
  stroke-miterlimit: 10;
}
.st116 {
  fill: #ffffff;
  stroke: #ffffff;
  stroke-width: 6;
  stroke-miterlimit: 10;
}
.st117 {
  fill: none;
  stroke: #000000;
  stroke-width: 10;
  stroke-miterlimit: 10;
}
.st118 {
  fill: #d2d2d2;
  stroke: #c9c9c9;
  stroke-width: 2;
  stroke-miterlimit: 10;
}
.filters {
  position: absolute;
  transform: translateX(31%);
  width: 60%;
  background-color: #ffffff;
  opacity: 0.9;
  border-radius: 15px;
  padding: 10px;
  max-width: 80%;
  font-size: 10px;
  font-weight: bold;
  bottom: 25px;
}

@media screen and (max-width: 345px) {
  .filters {
    bottom: 10px;
  }
}
@media (min-width: 800px) {
  .filters {
    font-size: 11px;
  }
}
@media (min-width: 900px) {
  .filters {
    font-size: 13px;
  }
}
@media (max-width: 400px) {
  .filters {
    width: 80% !important;
    max-width: 80% !important;
    transform: translateX(13%) !important;
  }
}

.is-pointer {
  cursor: default;
}
.tooltip-data {
  font-family: 'Avenir-Medium';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: #ffffff;
}
.tooltip-data .bold {
  font-family: 'Avenir-Bold';
}
.checkbox-list {
  padding-top: 4px;
}
</style>
